var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJ1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "348.32 450.43 348.32 475.9 385.57 475.9 426.66 475.9 426.66 450.43 348.32 450.43",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.04 443.3 345.04 450.43 429.4 450.43 429.4 443.3 385.57 443.3 345.04 443.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.22 475.9 426.66 475.9 426.66 450.43 429.4 450.43 429.4 443.3 385.57 443.3 385.57 449.77 387.22 475.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.28,
    y: 454.53,
    width: 15.89,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.23,
    y: 463.16,
    width: 20.4,
    height: 8.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.38 417.87 360.38 443.34 397.63 443.34 438.71 443.34 438.71 417.87 360.38 417.87",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.09 410.74 357.09 417.87 441.45 417.87 441.45 410.74 397.63 410.74 357.09 410.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.27 443.34 438.71 443.34 438.71 417.87 441.45 417.87 441.45 410.74 397.63 410.74 397.63 417.21 399.27 443.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.33,
    y: 421.97,
    width: 15.89,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.29,
    y: 430.6,
    width: 20.4,
    height: 8.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,469.22c-1-.86-3.25-3.6-1.52-6.78a6.05,6.05,0,0,1,3.2-2.25,13.15,13.15,0,0,0,3.51-1.82c1.91-1.62,2.43-4.31,3.7-6.47a8.08,8.08,0,0,1,7-4.21c3.28.15,6,2.83,7.25,5.88s1.28,6.43,1.31,9.73c0,1.82-.07,3.87-1.41,5.1s-3.09,1.15-4.76,1.1L39.35,469",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2,420H26.12l8.48,50.56a5.64,5.64,0,0,0,4,4.5l.17.05.42.11a7.46,7.46,0,0,0,.95.11v0l.23,0h21a5.57,5.57,0,0,0,1.16-.12,5.67,5.67,0,0,0,4.76-4.94l4.09-34.84.18-1.38h0l1.62-13.8Zm-8.88,32.25H59.49L60,437.58h5.6ZM66,437.58h4.62l-1.72,14.67H64.79Zm-13.8,30.94-.3-12.75h7l-.42,12.75Zm-7.52-12.75h6.76l.29,12.75H45.71Zm.52,12.75H39.57c-.54-3.44-1.24-7.92-2-12.75h6.68Zm-.8-16.27L43.3,437.58h7.76l.34,14.67Zm7.42,0-.33-14.67h8L59,452.25Zm-.42-18.19-.31-13.59h8.94l-.45,13.59Zm-.46,0H43L42,420.47h8.69Zm-8.42,0H34.15c-.3-1.88-.58-3.66-.83-5.26-.88-5.49-1.21-7.56-1.39-8.33H41.5Zm.27,3.52L44,452.25H37c-.23-1.49-.47-3-.71-4.5-.54-3.47-1.09-6.93-1.6-10.17Zm-6.28,14.67H32l-2.47-14.67h4.7C35,442.11,35.75,447.16,36.55,452.25Zm.55,3.52c.69,4.41,1.37,8.76,2,12.75H34.73L32.6,455.77ZM59,468.52l.42-12.75H64l-1.09,12.75Zm1.14-34.46.45-13.59H67l-1.16,13.59ZM31.48,420.47c.19,1,1.05,6.33,2.2,13.59H29l-2.28-13.59Zm35.55,48H63.4l1.09-12.75h4Zm4-34.46H66.34l1.16-13.59h5.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.54,
    y: 43.09,
    width: 85.44,
    height: 123.84,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.26,
    y: 43.09,
    width: 85.44,
    height: 123.84,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.87,
    y: 56.51,
    width: 64.21,
    height: 97.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.08,153.52s0-.17,0-.48,0-.77,0-1.37c0-1.22,0-3,0-5.32,0-4.65,0-11.43-.06-20,0-17.1-.06-41.33-.1-69.85l.21.21-64.2,0h0l.24-.23c0,36.59,0,70.34-.05,97l-.19-.19,46.74.1,12.91,0,3.39,0,1.17,0-1.13,0-3.36,0-12.87.05-46.85.09h-.18v-.18c0-26.67,0-60.42-.05-97v-.24h.24l64.2,0h.21v.22c0,28.58-.08,52.85-.1,70,0,8.54-.05,15.3-.06,19.94,0,2.3,0,4.07,0,5.28,0,.59,0,1,0,1.35S700.08,153.52,700.08,153.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.93,43.09a14.74,14.74,0,0,1-1.52,2.22c-1,1.32-2.4,3.13-4,5.08s-3.11,3.68-4.22,4.91a14.5,14.5,0,0,1-1.88,1.92,15.75,15.75,0,0,1,1.63-2.13l4.11-5,4.11-5A16.87,16.87,0,0,1,710.93,43.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.41,153.21a79.11,79.11,0,0,0,11.2,14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.61,167.21a12.63,12.63,0,0,1-2-1.77c-1.14-1.16-2.67-2.83-4.22-4.77a61.8,61.8,0,0,1-3.72-5.17,12.38,12.38,0,0,1-1.3-2.29,18.55,18.55,0,0,1,1.57,2.11c.94,1.32,2.27,3.13,3.81,5.06s3,3.62,4.1,4.83A19.78,19.78,0,0,1,711.61,167.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.25,166.83,636.44,153",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.44,153a87.6,87.6,0,0,1-5.42,7.05,85.56,85.56,0,0,1-5.77,6.75,86,86,0,0,1,5.41-7.05A84.32,84.32,0,0,1,636.44,153Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.26,43.09a77.68,77.68,0,0,1,5.43,6.5,76.68,76.68,0,0,1,5.07,6.78,78.45,78.45,0,0,1-5.43-6.49A77.61,77.61,0,0,1,625.26,43.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.18,76.1l0,.18c0,.13,0,.31.07.55a15.16,15.16,0,0,0,.42,2,14.22,14.22,0,0,0,1.24,3.06,13.15,13.15,0,0,0,2.68,3.44,43.18,43.18,0,0,0,4.21,3.25,22.11,22.11,0,0,1,4.5,4.16,20.83,20.83,0,0,1,3.31,5.91,18.59,18.59,0,0,1-.71,14.22,17.69,17.69,0,0,1-4,5.47c-1.57,1.48-3.21,2.72-4.59,4a14.61,14.61,0,0,0-3.19,4.21,14.42,14.42,0,0,0-1.42,7.46c0,.46.11.86.15,1.2s.12.64.18.87.1.4.13.53,0,.18,0,.18l-.06-.17-.15-.53c-.07-.23-.12-.52-.2-.87s-.14-.74-.17-1.2a13.52,13.52,0,0,1,.08-3.32,14.08,14.08,0,0,1,1.28-4.22,15.06,15.06,0,0,1,3.2-4.27c1.39-1.33,3-2.58,4.59-4.06a17.54,17.54,0,0,0,3.93-5.41,18.49,18.49,0,0,0,.7-14.06,20.16,20.16,0,0,0-3.27-5.85,21.8,21.8,0,0,0-4.45-4.14,44.13,44.13,0,0,1-4.21-3.29A13.32,13.32,0,0,1,661.83,82a14.64,14.64,0,0,1-1.6-5.17c0-.24,0-.42,0-.54S660.18,76.1,660.18,76.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.76,73.74a23.62,23.62,0,0,1,0,2.88,22.14,22.14,0,0,1-.42,3.37,12.89,12.89,0,0,1-1.57,4.2,10.5,10.5,0,0,1-.75,1q-.45.49-.93,1l-2,2c-1.4,1.36-2.91,2.8-4.42,4.39a20.12,20.12,0,0,0-3.78,5.68,17.76,17.76,0,0,0-1.54,7.14,16.25,16.25,0,0,0,1.66,7.09,14.54,14.54,0,0,0,4.3,5.24c1.75,1.31,3.63,2.26,5.24,3.37a14.53,14.53,0,0,1,2.2,1.79,13.32,13.32,0,0,1,3.48,6.13,12.64,12.64,0,0,1,.43,3.36,13.12,13.12,0,0,1-.17,2.14c-.05.23-.09.41-.11.54l-.05.19a1.29,1.29,0,0,1,0-.19c0-.13.06-.32.09-.55a13.57,13.57,0,0,0,.14-2.13,13.06,13.06,0,0,0-.47-3.33,13.88,13.88,0,0,0-1.83-4,13.69,13.69,0,0,0-1.64-2,15.61,15.61,0,0,0-2.19-1.76c-1.6-1.1-3.48-2-5.26-3.36a14.55,14.55,0,0,1-4.37-5.3,16.28,16.28,0,0,1-1.68-7.19,17.74,17.74,0,0,1,1.56-7.22,19.85,19.85,0,0,1,3.82-5.74c1.52-1.58,3-3,4.44-4.38l2-2c.33-.32.64-.64.92-1a8.79,8.79,0,0,0,.75-1A12.83,12.83,0,0,0,677.22,80a22.14,22.14,0,0,0,.45-3.34c.06-.93.07-1.65.08-2.14v-.55A1.31,1.31,0,0,1,677.76,73.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.55,85.63c0,.05-2,.3-4.53.54a44.74,44.74,0,0,1-4.54.33c0-.06,2-.3,4.52-.54A44.66,44.66,0,0,1,674.55,85.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.61,82c0,.06-3.21.15-7.16.21s-7.16,0-7.16,0,3.2-.15,7.16-.21S676.61,81.92,676.61,82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.63,77.71c0,.06-3.85.14-8.61.18s-8.61,0-8.61,0,3.86-.13,8.61-.17S677.63,77.65,677.63,77.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.41,115.34c0,.06-2.11,0-4.71-.2s-4.7-.37-4.7-.43,2.12,0,4.72.21S674.42,115.28,674.41,115.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.82,109.91a2.1,2.1,0,0,1-.54,0h-1.49c-1.26,0-3-.06-4.92-.17s-3.66-.26-4.91-.39l-1.48-.18a2.28,2.28,0,0,1-.54-.1,2.86,2.86,0,0,1,.55,0l1.49.1c1.25.1,3,.23,4.9.34s3.65.18,4.91.22l1.49.06A3.37,3.37,0,0,1,676.82,109.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.53,104.62a3.93,3.93,0,0,1-.61,0l-1.66-.16c-1.4-.13-3.33-.29-5.47-.42s-4.09-.17-5.5-.2l-1.66,0a2.72,2.72,0,0,1-.61,0,3.63,3.63,0,0,1,.61,0c.39,0,1,0,1.67,0,1.4,0,3.35,0,5.5.14s4.08.31,5.48.48l1.65.23A2.43,2.43,0,0,1,677.53,104.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.77,98.82a1.57,1.57,0,0,1-.47,0l-1.28,0c-1.09,0-2.59-.09-4.24-.11s-3.16,0-4.25,0h-1.28a2.42,2.42,0,0,1-.47,0,1.47,1.47,0,0,1,.47-.06c.3,0,.74,0,1.28-.08,1.09,0,2.59-.07,4.25-.05s3.16.1,4.24.18l1.29.11A2,2,0,0,1,675.77,98.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.44,94.31a36.46,36.46,0,0,1-4.05,0,37.44,37.44,0,0,1-4-.22,36.4,36.4,0,0,1,4,0A37.44,37.44,0,0,1,674.44,94.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.88,124.14a1.72,1.72,0,0,1-.42,0l-1.16,0-3.82-.12-3.82-.1-1.15,0a1.84,1.84,0,0,1-.43,0,1.34,1.34,0,0,1,.43,0c.27,0,.66,0,1.15,0,1,0,2.34,0,3.83,0s2.84.12,3.82.19l1.15.1C676.74,124.1,676.89,124.12,676.88,124.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.21,129.17c0,.06-3.6,0-8-.11s-8-.27-8-.33,3.6,0,8,.11S679.21,129.11,679.21,129.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.35,133.09c0,.06-4,.12-8.89.13s-8.88,0-8.88-.1,4-.11,8.88-.12S680.35,133,680.35,133.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.61,178.06a6.24,6.24,0,0,0-.64-1.78c-.81-2-.33-4.22-.24-6.37a1.7,1.7,0,0,0-.18-1,.64.64,0,0,0-.9-.21.91.91,0,0,0-.22.63c-.07.73-.23,2.43-.6,2.34a5,5,0,0,1-1.88-1.74,2.59,2.59,0,0,0-.48-.61.7.7,0,0,0-.73-.12c-.36.2-.34.73-.19,1.12.71,1.95,2.89,3.1,3.56,5.08a10.84,10.84,0,0,1,.34,2.36,2.87,2.87,0,0,0,.27,1.08,1.09,1.09,0,0,0,.9.59C221.25,179.42,221.66,178.68,221.61,178.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1,183.43a6,6,0,0,0-1.44-1.21c-1.7-1.32-2.41-3.5-3.4-5.4a1.67,1.67,0,0,0-.67-.79.62.62,0,0,0-.88.27.9.9,0,0,0,.12.65c.3.67,1,2.22.65,2.33a4.85,4.85,0,0,1-2.49-.57,2.82,2.82,0,0,0-.73-.28.7.7,0,0,0-.69.26c-.21.35.08.8.39,1.06,1.6,1.34,4.06,1.24,5.63,2.62a9.94,9.94,0,0,1,1.47,1.87,2.83,2.83,0,0,0,.78.8,1.11,1.11,0,0,0,1.07.07A1.21,1.21,0,0,0,212.1,183.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94,195.45a6.26,6.26,0,0,0-1.84.4c-2.07.55-4.23-.21-6.34-.58a1.67,1.67,0,0,0-1,0,.64.64,0,0,0-.33.87,1,1,0,0,0,.6.3c.71.16,2.38.54,2.25.89a5,5,0,0,1-2,1.64,2.77,2.77,0,0,0-.66.4.71.71,0,0,0-.21.71c.15.38.68.43,1.08.33,2-.45,3.45-2.47,5.49-2.87a10.61,10.61,0,0,1,2.39,0,2.78,2.78,0,0,0,1.11-.13,1.1,1.1,0,0,0,.7-.81C208.25,196,207.57,195.48,206.94,195.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.88,191.61a6.2,6.2,0,0,0,1.75-.69c2-.86,4.22-.45,6.36-.42a1.7,1.7,0,0,0,1-.2.63.63,0,0,0,.18-.91.91.91,0,0,0-.63-.21c-.73-.05-2.43-.16-2.36-.53a5,5,0,0,1,1.69-1.92,2.64,2.64,0,0,0,.59-.51.68.68,0,0,0,.1-.73c-.2-.36-.73-.31-1.12-.16-1.93.77-3,3-5,3.7a10.32,10.32,0,0,1-2.36.41,2.8,2.8,0,0,0-1.07.3,1.11,1.11,0,0,0-.57.91C236.51,191.28,237.25,191.67,237.88,191.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47,181.73a6.42,6.42,0,0,0,1-1.61c1-1.88,3.07-2.93,4.79-4.21a1.76,1.76,0,0,0,.68-.78.64.64,0,0,0-.41-.84,1,1,0,0,0-.63.23c-.61.4-2,1.35-2.19,1a4.87,4.87,0,0,1,.17-2.56,2.71,2.71,0,0,0,.16-.75.7.7,0,0,0-.37-.64c-.38-.16-.77.19-1,.55-1.07,1.79-.59,4.2-1.7,6a10,10,0,0,1-1.62,1.76,2.8,2.8,0,0,0-.66.9,1.08,1.08,0,0,0,.1,1.06A1.2,1.2,0,0,0,230.47,181.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,202.32a6.07,6.07,0,0,0,1.5,1.14c1.77,1.21,2.6,3.35,3.7,5.19a1.72,1.72,0,0,0,.71.75.63.63,0,0,0,.87-.32.89.89,0,0,0-.16-.64c-.34-.65-1.14-2.16-.79-2.29a4.92,4.92,0,0,1,2.53.43,2.79,2.79,0,0,0,.74.24.68.68,0,0,0,.67-.3c.2-.36-.12-.8-.45-1-1.67-1.24-4.12-1-5.76-2.29a10.39,10.39,0,0,1-1.58-1.79,2.7,2.7,0,0,0-.83-.75,1.1,1.1,0,0,0-1.07,0A1.19,1.19,0,0,0,236.12,202.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.35,204.75a6,6,0,0,0-1.27,1.39c-1.37,1.64-3.58,2.27-5.51,3.19a1.69,1.69,0,0,0-.82.64.62.62,0,0,0,.23.89,1,1,0,0,0,.66-.09c.68-.28,2.26-.94,2.35-.57a4.82,4.82,0,0,1-.66,2.47,2.7,2.7,0,0,0-.31.72.68.68,0,0,0,.24.69c.34.23.8,0,1.07-.35,1.4-1.54,1.39-4,2.83-5.52a10.79,10.79,0,0,1,1.92-1.41,2.7,2.7,0,0,0,.83-.75A1.09,1.09,0,0,0,213,205,1.2,1.2,0,0,0,211.35,204.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.64,210a5.93,5.93,0,0,0,.42,1.83c.55,2.08-.2,4.24-.55,6.36a1.72,1.72,0,0,0,.05,1,.63.63,0,0,0,.87.32.91.91,0,0,0,.3-.59c.16-.72.53-2.39.88-2.26a5,5,0,0,1,1.65,2,2.81,2.81,0,0,0,.41.66.7.7,0,0,0,.7.21c.39-.15.43-.69.33-1.09-.47-2-2.48-3.44-2.9-5.48a10.51,10.51,0,0,1-.05-2.38,2.76,2.76,0,0,0-.14-1.11,1.1,1.1,0,0,0-.81-.7C224.17,208.64,223.67,209.32,223.64,210Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.34,
    cy: 195.21,
    r: 17.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.6,188.71a.63.63,0,0,0-.77.18,2.26,2.26,0,0,0-.45.71,1.59,1.59,0,0,0-.19-.83.68.68,0,0,0-.78-.32.81.81,0,0,0-.43.52,1.93,1.93,0,0,0,.7,2.19,1.22,1.22,0,0,0,.88.25,1.37,1.37,0,0,0,.91-.67,2.55,2.55,0,0,0,.41-1.29A.81.81,0,0,0,218.6,188.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.13,196.32a.64.64,0,0,0-.36.71,2.8,2.8,0,0,0,.27.8,1.52,1.52,0,0,0-.76-.38.68.68,0,0,0-.74.4.83.83,0,0,0,.13.66,1.94,1.94,0,0,0,2.14.85,1.28,1.28,0,0,0,.75-.53,1.39,1.39,0,0,0,.06-1.13,2.59,2.59,0,0,0-.74-1.13A.79.79,0,0,0,211.13,196.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.32,204a.64.64,0,0,0-.74.26,2.56,2.56,0,0,0-.37.76,1.45,1.45,0,0,0-.28-.79.69.69,0,0,0-.81-.24.81.81,0,0,0-.37.57,2,2,0,0,0,.95,2.1,1.21,1.21,0,0,0,.91.14,1.38,1.38,0,0,0,.82-.77,2.61,2.61,0,0,0,.26-1.32A.8.8,0,0,0,220.32,204Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.86,197.37a.63.63,0,0,0-.74.26,2.44,2.44,0,0,0-.37.76,1.53,1.53,0,0,0-.29-.8.67.67,0,0,0-.8-.23.79.79,0,0,0-.37.56,1.91,1.91,0,0,0,.94,2.1,1.27,1.27,0,0,0,.91.15,1.43,1.43,0,0,0,.83-.77,2.65,2.65,0,0,0,.26-1.33A.8.8,0,0,0,225.86,197.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.64,203.58a.64.64,0,0,0-.75.26,2.44,2.44,0,0,0-.37.76,1.51,1.51,0,0,0-.28-.8.68.68,0,0,0-.81-.23.77.77,0,0,0-.37.56,2,2,0,0,0,.95,2.1,1.26,1.26,0,0,0,.91.15,1.44,1.44,0,0,0,.82-.77,2.67,2.67,0,0,0,.26-1.33A.78.78,0,0,0,232.64,203.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.35,193.49a.64.64,0,0,0-.54.57,2.63,2.63,0,0,0,0,.84,1.48,1.48,0,0,0-.61-.58.68.68,0,0,0-.83.16.82.82,0,0,0-.07.67,2,2,0,0,0,1.79,1.45,1.3,1.3,0,0,0,.88-.29,1.4,1.4,0,0,0,.39-1.06A2.71,2.71,0,0,0,238,194,.81.81,0,0,0,237.35,193.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.52,188.25a.63.63,0,0,0-.55.57,2.38,2.38,0,0,0,0,.84,1.57,1.57,0,0,0-.62-.58.67.67,0,0,0-.82.16.82.82,0,0,0-.08.67,1.93,1.93,0,0,0,1.8,1.44,1.23,1.23,0,0,0,.87-.28,1.4,1.4,0,0,0,.39-1.06,2.48,2.48,0,0,0-.37-1.3A.78.78,0,0,0,228.52,188.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.79,181.1a.64.64,0,0,0-.76.21,2.31,2.31,0,0,0-.41.74,1.57,1.57,0,0,0-.24-.82.68.68,0,0,0-.79-.28.82.82,0,0,0-.4.54,1.94,1.94,0,0,0,.82,2.16,1.31,1.31,0,0,0,.9.2,1.4,1.4,0,0,0,.86-.72,2.54,2.54,0,0,0,.34-1.31A.77.77,0,0,0,222.79,181.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.73,185.46a.64.64,0,0,0-.77-.17,2.47,2.47,0,0,0-.71.46,1.61,1.61,0,0,0,.17-.83.67.67,0,0,0-.57-.62.81.81,0,0,0-.61.29,2,2,0,0,0-.29,2.29,1.25,1.25,0,0,0,.71.59,1.4,1.4,0,0,0,1.1-.22,2.57,2.57,0,0,0,.91-1A.8.8,0,0,0,235.73,185.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.44,187.84a.74.74,0,0,0-.19.76,1.92,1.92,0,0,0,.32.64,1,1,0,0,0-.67-.09.74.74,0,0,0-.56.59.75.75,0,0,0,.19.57,1.39,1.39,0,0,0,1.88.09,1.46,1.46,0,0,0,.55-.72,1.45,1.45,0,0,0-.1-1.05,1.84,1.84,0,0,0-.76-.8A.59.59,0,0,0,210.44,187.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.66,269.69a4.57,4.57,0,1,1-.92,6.4A4.58,4.58,0,0,1,447.66,269.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.91,262a4.57,4.57,0,1,1-.92,6.4A4.58,4.58,0,0,1,431.91,262Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.47,278.86a4.57,4.57,0,1,1-.91,6.4A4.56,4.56,0,0,1,445.47,278.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.48,253.67a4.57,4.57,0,1,1-.92,6.4A4.57,4.57,0,0,1,433.48,253.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.68,261.91a4.57,4.57,0,1,1-.92,6.4A4.58,4.58,0,0,1,450.68,261.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.09,262.36a4.57,4.57,0,1,1-.92,6.4A4.57,4.57,0,0,1,444.09,262.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.36,259.78a4.57,4.57,0,1,1-.92,6.4A4.56,4.56,0,0,1,461.36,259.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.72,264.88a4.57,4.57,0,1,1-.92,6.4A4.57,4.57,0,0,1,440.72,264.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.07,265.92a4.57,4.57,0,1,1-.92,6.4A4.58,4.58,0,0,1,457.07,265.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.67,257.46a4.57,4.57,0,1,1-.92,6.4A4.58,4.58,0,0,1,454.67,257.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,254.88a4.57,4.57,0,1,1-.92,6.4A4.58,4.58,0,0,1,448,254.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.29,270.17a4.57,4.57,0,1,1-.92,6.4A4.58,4.58,0,0,1,464.29,270.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.87,272.76a4.57,4.57,0,1,1-.92,6.4A4.58,4.58,0,0,1,441.87,272.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.08,278.78a4.57,4.57,0,1,1-.92,6.4A4.56,4.56,0,0,1,437.08,278.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.36,257a4.58,4.58,0,1,1-.91,6.4A4.56,4.56,0,0,1,437.36,257Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.59,218.53l1.24,1.41a.86.86,0,0,0,.61.25.88.88,0,0,0,.61-.25.86.86,0,0,0,.25-.61l0-.23a1,1,0,0,0-.22-.38l-1.24-1.4a.89.89,0,0,0-.61-.26.89.89,0,0,0-.87.87l0,.22a.77.77,0,0,0,.22.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.42,214.47a15.81,15.81,0,0,0,.53,1.78.88.88,0,0,0,.4.51.85.85,0,0,0,.66.09.85.85,0,0,0,.51-.4.81.81,0,0,0,.09-.66,15.21,15.21,0,0,1-.53-1.78.83.83,0,0,0-.39-.51.86.86,0,0,0-1.27,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,214.6a10,10,0,0,0-.82,1.41.75.75,0,0,0-.1.32.6.6,0,0,0,0,.35.86.86,0,0,0,1.06.6.85.85,0,0,0,.51-.4,9.42,9.42,0,0,1,.82-1.41.75.75,0,0,0,.1-.32.6.6,0,0,0,0-.35.83.83,0,0,0-.39-.51.87.87,0,0,0-.67-.09l-.2.09a.84.84,0,0,0-.31.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,221.48l1.92-1.16a.88.88,0,0,0,.4-.51.86.86,0,0,0-1.27-1L67.63,220a.91.91,0,0,0-.4.52.9.9,0,0,0,.09.66.88.88,0,0,0,.51.4.92.92,0,0,0,.67-.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.82,227.11l2.74.08a.86.86,0,0,0,.86-.86.88.88,0,0,0-.86-.86l-2.74-.08a.85.85,0,0,0-.86.86.87.87,0,0,0,.86.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,232.84,70,234.2a.87.87,0,0,0,1.27-1,1,1,0,0,0-.4-.51L69,231.36a.81.81,0,0,0-.66-.09.87.87,0,0,0-.52.4.85.85,0,0,0-.08.66.94.94,0,0,0,.39.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.76,236.47c.31.53.62,1.06.92,1.59a.91.91,0,0,0,.52.4.87.87,0,0,0,1.06-.6.92.92,0,0,0-.09-.67l-.93-1.59a.85.85,0,0,0-.51-.4.87.87,0,0,0-1.06.6.92.92,0,0,0,.09.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.51,236.71l-.31,1.59a1,1,0,0,0,.09.67.83.83,0,0,0,.51.39.92.92,0,0,0,.67-.08.85.85,0,0,0,.39-.52l.31-1.59a.89.89,0,0,0-.08-.66.91.91,0,0,0-.52-.4.85.85,0,0,0-.66.09.88.88,0,0,0-.4.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.22,236.58a6.19,6.19,0,0,1,.7-.65l-.18.14.38-.27a.88.88,0,0,0,.4-.51.69.69,0,0,0,0-.35.63.63,0,0,0-.1-.32.88.88,0,0,0-1.18-.31A6.05,6.05,0,0,0,51,235.37a.84.84,0,0,0-.25.6.67.67,0,0,0,.07.34.54.54,0,0,0,.18.27.87.87,0,0,0,.61.26.89.89,0,0,0,.61-.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5,231.9l1.54-.68-.87-1.49-.32.15.87,1.49,1-.51a.87.87,0,0,0,.39-.51.92.92,0,0,0-.08-.67.89.89,0,0,0-.52-.39.94.94,0,0,0-.66.08l-1,.51a.84.84,0,0,0-.4.52.87.87,0,0,0,.6,1.06l.23,0a.86.86,0,0,0,.44-.12l.32-.15a.89.89,0,0,0,.4-.51.92.92,0,0,0-.09-.67.89.89,0,0,0-.52-.39l-.23,0a.92.92,0,0,0-.43.11l-1.54.68a.87.87,0,0,0-.4.52.87.87,0,0,0,.6,1.06l.23,0a.86.86,0,0,0,.44-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.36,224.93l2.07.42a.85.85,0,0,0,.66-.09.88.88,0,0,0,.4-.51.85.85,0,0,0-.09-.66.79.79,0,0,0-.51-.4l-2.07-.42a.92.92,0,0,0-.67.08.85.85,0,0,0-.39.52.89.89,0,0,0,.08.66.83.83,0,0,0,.52.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.63,
    cy: 226.59,
    r: 11.72,
    transform: "translate(-174.04 243.85) rotate(-79.48)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,213.7l-.06,1.17a1.08,1.08,0,0,0,.11.5,1,1,0,0,0,.27.41,1,1,0,0,0,.42.27.93.93,0,0,0,.49.11l.35,0a1.26,1.26,0,0,0,.57-.33l.2-.26a1.25,1.25,0,0,0,.18-.65l.06-1.17a1.43,1.43,0,0,0-.38-.92,1,1,0,0,0-.42-.26.94.94,0,0,0-.49-.12l-.35,0a1.26,1.26,0,0,0-.57.33L59,213a1.28,1.28,0,0,0-.18.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.39,219.61,69,218.07a1,1,0,0,0,.26-.42.93.93,0,0,0,.11-.49.94.94,0,0,0-.11-.5,1,1,0,0,0-.26-.42,1.36,1.36,0,0,0-.92-.38,1.41,1.41,0,0,0-.91.38l-1.58,1.54a1,1,0,0,0-.26.42.94.94,0,0,0-.11.5,1,1,0,0,0,.11.5,1,1,0,0,0,.26.41,1.28,1.28,0,0,0,.92.38,1.36,1.36,0,0,0,.91-.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.13,224.58l2.08-.32a.94.94,0,0,0,.44-.23,1,1,0,0,0,.33-.36,1.34,1.34,0,0,0,.13-1,1.3,1.3,0,0,0-.59-.77l-.31-.13a1.35,1.35,0,0,0-.69,0l-2.07.32a1,1,0,0,0-.44.23,1.07,1.07,0,0,0-.34.36,1.34,1.34,0,0,0-.13,1,1.29,1.29,0,0,0,.6.77l.31.13a1.13,1.13,0,0,0,.68,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.76,230.69l1.82.76a1,1,0,0,0,.51,0,1,1,0,0,0,.48-.15.93.93,0,0,0,.37-.34,1,1,0,0,0,.23-.43,1.33,1.33,0,0,0-.13-1l-.2-.26a1.35,1.35,0,0,0-.58-.33l-1.81-.76a1,1,0,0,0-.52,0,.93.93,0,0,0-.48.15,1,1,0,0,0-.36.33,1,1,0,0,0-.23.44,1.3,1.3,0,0,0,.13,1l.2.26a1.26,1.26,0,0,0,.57.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9,235.62,67,236.73a.87.87,0,0,0,.41.27,1.19,1.19,0,0,0,1,0,.87.87,0,0,0,.41-.27l.21-.26a1.34,1.34,0,0,0,.17-.65l0-.34a1.38,1.38,0,0,0-.34-.57l-1.12-1.12a.87.87,0,0,0-.41-.27,1.19,1.19,0,0,0-1,0,.87.87,0,0,0-.41.27l-.21.26a1.34,1.34,0,0,0-.17.65l0,.35a1.38,1.38,0,0,0,.34.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13,236.57c0,.57,0,1.15,0,1.73a1.31,1.31,0,0,0,.38.91.87.87,0,0,0,.41.27,1,1,0,0,0,.5.11,1.34,1.34,0,0,0,.91-.38,1.31,1.31,0,0,0,.38-.91l0-1.73a1.32,1.32,0,0,0-.38-.92,1,1,0,0,0-.41-.27,1.08,1.08,0,0,0-.5-.11,1.34,1.34,0,0,0-.91.38,1.32,1.32,0,0,0-.38.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.12,238.92a14,14,0,0,0,1.12-1.75,1.3,1.3,0,0,0,.13-1,.94.94,0,0,0-.23-.44,1,1,0,0,0-.36-.33,1.3,1.3,0,0,0-1.77.46,14.13,14.13,0,0,1-1.12,1.76,1,1,0,0,0-.15.48,1.15,1.15,0,0,0,.25,1,.91.91,0,0,0,.37.33,1.27,1.27,0,0,0,1,.13l.31-.13a1.27,1.27,0,0,0,.46-.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.06,235.22a13.07,13.07,0,0,0,1.61-1.05,1.07,1.07,0,0,0,.36-.34,1.15,1.15,0,0,0,.25-1,.93.93,0,0,0-.15-.48,1.32,1.32,0,0,0-.77-.6l-.35,0a1.34,1.34,0,0,0-.65.17A13.15,13.15,0,0,1,47.75,233a1.53,1.53,0,0,0-.59.77,1,1,0,0,0,0,.52,1,1,0,0,0,.16.48,1.26,1.26,0,0,0,.77.59,1.35,1.35,0,0,0,1-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,228.62l2.26,0a1.34,1.34,0,0,0,.91-.38,1.31,1.31,0,0,0,.38-.91,1.26,1.26,0,0,0-.38-.92,1.39,1.39,0,0,0-.91-.38L46,226a1.3,1.3,0,0,0-1.3,1.3,1.34,1.34,0,0,0,.38.91,1.36,1.36,0,0,0,.92.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.13,221.36l2,1.15a1.32,1.32,0,0,0,1,.13,1.36,1.36,0,0,0,.78-.59,1.4,1.4,0,0,0,.13-1,1.36,1.36,0,0,0-.6-.77l-2-1.15a1.34,1.34,0,0,0-1-.13,1.29,1.29,0,0,0-.9,1.59,1.34,1.34,0,0,0,.59.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.76,216.07,53,217.88a1,1,0,0,0,.33.36,1,1,0,0,0,.44.23,1,1,0,0,0,.52,0,.93.93,0,0,0,.48-.15,1.3,1.3,0,0,0,.59-.77,1.25,1.25,0,0,0-.13-1c-.42-.6-.84-1.2-1.25-1.81a1.07,1.07,0,0,0-.34-.36,1.15,1.15,0,0,0-.95-.25,1,1,0,0,0-.48.15,1.32,1.32,0,0,0-.6.77,1.33,1.33,0,0,0,.13,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.71,231A1.3,1.3,0,0,0,60,229.67,1.29,1.29,0,1,0,58.71,231Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.22,230.18a1.3,1.3,0,0,0,1.29-1.29,1.31,1.31,0,0,0-1.29-1.29,1.3,1.3,0,0,0-1.29,1.29,1.31,1.31,0,0,0,1.29,1.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.72,222.66a1.07,1.07,0,1,0-1.06-1.07,1.08,1.08,0,0,0,1.06,1.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.37,223.25a1.3,1.3,0,1,0-1.29-1.3,1.32,1.32,0,0,0,1.29,1.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.84,221.57a1.3,1.3,0,1,0-1.29-1.3,1.32,1.32,0,0,0,1.29,1.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.91,227.87a1.31,1.31,0,0,0,1.3-1.29,1.32,1.32,0,0,0-1.3-1.29,1.29,1.29,0,0,0,0,2.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.51,235a1.29,1.29,0,1,0-1.3-1.29,1.31,1.31,0,0,0,1.3,1.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6,230.26a.87.87,0,1,0,0-1.73.87.87,0,0,0-.86.86.88.88,0,0,0,.86.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.07,226.25a.87.87,0,0,0,.86-.86.86.86,0,1,0-.86.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,226.9a.87.87,0,1,0-.86-.87.88.88,0,0,0,.86.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,219.72a.87.87,0,1,0-.86-.87.88.88,0,0,0,.86.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.19,223.11a.86.86,0,1,0,0-1.72.86.86,0,1,0,0,1.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73,226.2a.87.87,0,0,0,.86-.86.86.86,0,1,0-.86.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.34,230.89a.86.86,0,0,0,.86-.86.86.86,0,1,0-.86.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.82,218.32a.86.86,0,1,0-.87-.86.88.88,0,0,0,.87.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,226a.86.86,0,1,0-.86-.86A.88.88,0,0,0,65,226Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.92,231.12a.87.87,0,1,0-.86-.86.88.88,0,0,0,.86.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8,235.26a.87.87,0,0,0,.86-.86.86.86,0,1,0-1.72,0,.87.87,0,0,0,.86.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1,233.79a.87.87,0,0,0,.86-.86.86.86,0,1,0-.86.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.64,223.52a.86.86,0,1,0-.86-.86.87.87,0,0,0,.86.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.88,
    y: 192.8,
    width: 70.01,
    height: 101.47,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.38,
    y: 192.8,
    width: 70.01,
    height: 101.47,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.07,
    y: 203.79,
    width: 52.61,
    height: 79.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.68,283.28s0-.13,0-.39,0-.64,0-1.13c0-1,0-2.46,0-4.36,0-3.81,0-9.36,0-16.37,0-14-.06-33.87-.09-57.24l.17.17-52.6,0h0l.19-.19c0,30,0,57.64,0,79.49l-.16-.15,38.3.08,10.58,0h2.77l1,0-.92,0H689l-10.55,0-38.39.08h-.15v-.15c0-21.85,0-49.5,0-79.49v-.19h53v.18c0,23.42-.07,43.31-.09,57.35,0,7,0,12.54,0,16.34,0,1.88,0,3.33,0,4.32,0,.49,0,.85,0,1.11S692.68,283.28,692.68,283.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.58,192.8a13.1,13.1,0,0,1-1.25,1.81c-.81,1.09-2,2.57-3.28,4.17s-2.55,3-3.46,4a11.82,11.82,0,0,1-1.54,1.57,13.14,13.14,0,0,1,1.33-1.74l3.37-4.09,3.37-4.09A13.54,13.54,0,0,1,701.58,192.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693,283a65.16,65.16,0,0,0,9.18,11.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.13,294.5a10.09,10.09,0,0,1-1.6-1.45,50.86,50.86,0,0,1-3.46-3.91,50.05,50.05,0,0,1-3.05-4.23A10.42,10.42,0,0,1,693,283a14.22,14.22,0,0,1,1.29,1.73c.78,1.09,1.86,2.57,3.13,4.15s2.47,3,3.36,4A14.78,14.78,0,0,1,702.13,294.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.37,294.19l9.17-11.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.54,282.88a72.42,72.42,0,0,1-4.44,5.77,68.34,68.34,0,0,1-4.73,5.54,67.22,67.22,0,0,1,4.43-5.78A68,68,0,0,1,640.54,282.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.38,192.8a64.69,64.69,0,0,1,4.45,5.32,63.24,63.24,0,0,1,4.15,5.56,64.39,64.39,0,0,1-4.45-5.32A61.86,61.86,0,0,1,631.38,192.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.66,243.64a4.33,4.33,0,1,1-4.33-4.33A4.32,4.32,0,0,1,674.66,243.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677,228.41a3.24,3.24,0,1,1-3.23-3.24A3.23,3.23,0,0,1,677,228.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.39,233.38a2.34,2.34,0,1,1-2.33-2.34A2.33,2.33,0,0,1,664.39,233.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.29,257.91a1.45,1.45,0,0,1-2-2.06,1.45,1.45,0,1,1,2,2.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.59,246.39a2.34,2.34,0,1,1-2.34-2.34A2.34,2.34,0,0,1,657.59,246.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.33,243.64a42.16,42.16,0,0,1,3.23,6.22,41.75,41.75,0,0,1,2.7,6.46A42.66,42.66,0,0,1,673,250.1,43.79,43.79,0,0,1,670.33,243.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670,244.08a43.27,43.27,0,0,1-7,1.33,44.87,44.87,0,0,1-7.14.77,87.89,87.89,0,0,1,14.18-2.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.69,242a17.42,17.42,0,0,1-4.13-4,17.91,17.91,0,0,1-3.11-4.82c.15-.09,1.57,2,3.56,4.45S669.8,241.88,669.69,242Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.75,228.41h0s0,0,0,0h0v.11l-.08.42c-.1.49-.21,1-.33,1.52-.29,1.29-.73,3.05-1.22,5a58.14,58.14,0,0,1-2,7c-.17,0,.41-3.25,1.42-7.14.49-2,1-3.71,1.38-5,.2-.63.38-1.14.52-1.48a2.26,2.26,0,0,1,.18-.4.35.35,0,0,1,.06-.09l0,0s.06,0,0,0A0,0,0,0,1,673.75,228.41Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.59,474.57c0,.15-149.37.26-333.57.26s-333.61-.11-333.61-.26,149.33-.26,333.61-.26S712.59,474.43,712.59,474.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.11,451.82s-3.52-24.18-3.22-38.24,0-29.89,0-29.89h1.62s-1.1,27.92.1,44.76,4.33,23.37,4.33,23.37h-2.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.58,356.49a3.28,3.28,0,0,0-5-2.14c-4.89,1.73-9.23,10.86-11.21,15.66l6.5,21.9C488.6,381,490.63,366.75,486.58,356.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.73,355.21a1.23,1.23,0,0,1-.1.29c-.08.21-.19.47-.31.8-.29.69-.69,1.69-1.17,2.93-.95,2.49-2.17,6-3.26,9.88s-1.84,7.53-2.3,10.16c-.23,1.31-.4,2.37-.52,3.11-.05.34-.1.62-.13.85a1.48,1.48,0,0,1-.07.29,1,1,0,0,1,0-.3c0-.22.06-.51.09-.85.08-.75.23-1.82.43-3.14A95.39,95.39,0,0,1,479.63,369a92.19,92.19,0,0,1,3.35-9.88c.5-1.23.92-2.23,1.24-2.9l.36-.78A1.41,1.41,0,0,1,484.73,355.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,397.16a19.83,19.83,0,0,1-10-16.65c-.23-4.86,1.26-9.63,3-14.19a1.86,1.86,0,0,1,.69-1,1.75,1.75,0,0,1,1.66.26c4.43,2.52,7.11,7.33,8.54,12.22a24.6,24.6,0,0,1,1,10,16.66,16.66,0,0,1-4.82,9.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,397.16a.94.94,0,0,1,0-.29c0-.22,0-.5,0-.84,0-.73,0-1.78-.09-3.09a85.44,85.44,0,0,0-1.13-10.11c-.68-3.93-1.5-7.44-2.1-10-.3-1.24-.54-2.26-.72-3l-.19-.82a1.24,1.24,0,0,1,0-.3,1.71,1.71,0,0,1,.1.28l.24.81c.2.7.48,1.72.8,3,.65,2.52,1.5,6,2.18,10A73.23,73.23,0,0,1,474,392.94c0,1.3,0,2.36,0,3.09q0,.51,0,.84A1,1,0,0,1,474,397.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M474,397.16a19.83,19.83,0,0,1-10-16.65c-.23-4.86,1.26-9.63,3-14.19a1.86,1.86,0,0,1,.69-1,1.75,1.75,0,0,1,1.66.26c4.43,2.52,7.11,7.33,8.54,12.22a24.6,24.6,0,0,1,1,10,16.66,16.66,0,0,1-4.82,9.35"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M480.85,434.15c6,1.32,10.94,5.55,16.72,7.61,3.83,1.36,8.16,1.84,11.21,4.52-.73-1.86-2.47-3.09-4.16-4.14a74.49,74.49,0,0,0-15.15-7.24c-2.72-.94-5.67-1.72-8.45-.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.18,439.5c-7.5-.12-15.41-6.52-22.89-6.9,7.83-2.52,19-.46,22.89,6.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.12,421.48a24.39,24.39,0,0,1,12-.81,72.26,72.26,0,0,1,11.72,3.18c-.38-2.6-2.49-4.56-4.47-6.3a31.47,31.47,0,0,0-4.71-3.61,10.5,10.5,0,0,0-5.64-1.6,8.93,8.93,0,0,0-6.23,3.14,10.36,10.36,0,0,0-2.67,6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.71,413.19c-4.73-4-11.89-3.64-18.1-3.5a148,148,0,0,1,28.07,17.49C469.93,422.79,465.68,418.29,459.71,413.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.71,413.19c-4.73-4-11.89-3.64-18.1-3.5a148,148,0,0,1,28.07,17.49C469.93,422.79,465.68,418.29,459.71,413.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M477.24,407.62a53.68,53.68,0,0,1,7.27-4.22c2.49-1.14,4.81-2.94,7.22-4.24,3.11-1.68,5.81-4,8.67-6.12s6-4,9.5-4.54a18.88,18.88,0,0,0-8.64.5,56,56,0,0,0-8.14,3.17c-3.69,1.66-7.44,3.36-10.45,6.06s-5.74,5.36-5.43,9.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.44,439.5a1.28,1.28,0,0,1-.24-.11l-.66-.34c-.56-.3-1.38-.74-2.4-1.26-.5-.26-1.06-.54-1.67-.83s-1.26-.59-2-.89a28.83,28.83,0,0,0-4.63-1.61,9.73,9.73,0,0,0-4.81-.12,13.29,13.29,0,0,0-2,.6,10.6,10.6,0,0,0-3.72,2.56c-.44.47-.65.75-.67.74s0-.08.14-.22a6.23,6.23,0,0,1,.45-.59,9.93,9.93,0,0,1,2-1.8,10.06,10.06,0,0,1,1.67-.89,13.22,13.22,0,0,1,2.07-.64,9.85,9.85,0,0,1,4.93.1,26.58,26.58,0,0,1,4.67,1.64c.69.31,1.34.61,1.94.92s1.17.59,1.67.87c1,.53,1.81,1,2.36,1.33l.63.39A1,1,0,0,1,497.44,439.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.58,435.77a2.49,2.49,0,0,1,.47.14,10.73,10.73,0,0,1,1.23.53,14.87,14.87,0,0,1,6.27,6,11,11,0,0,1,.58,1.2,1.62,1.62,0,0,1,.16.47c-.05,0-.33-.62-.9-1.57a16.62,16.62,0,0,0-6.2-6C467.21,436.07,466.57,435.82,466.58,435.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,412.81l.32.1.9.32,1.42.52c.56.21,1.16.51,1.84.81a43.65,43.65,0,0,1,9.77,6.23,46.34,46.34,0,0,1,4.56,4.49,51,51,0,0,1,3.24,4.1c.86,1.22,1.51,2.23,2,2.93l.51.8a1.73,1.73,0,0,1,.17.29s-.08-.08-.21-.26-.32-.43-.56-.78c-.47-.68-1.14-1.67-2-2.87s-2-2.58-3.26-4a49.53,49.53,0,0,0-4.55-4.45,45.86,45.86,0,0,0-9.68-6.27c-.68-.3-1.27-.62-1.82-.84l-1.4-.56-.88-.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.39,417.26a2.37,2.37,0,0,1-.6-.08l-.69-.12c-.27-.05-.58-.06-.92-.09a9.42,9.42,0,0,0-5.17,1,9,9,0,0,0-2.34,1.74,10.32,10.32,0,0,0-1.51,1.87,15.19,15.19,0,0,0-1,2,2.38,2.38,0,0,1,.16-.59,7.7,7.7,0,0,1,.72-1.48,9.61,9.61,0,0,1,1.49-1.94,9,9,0,0,1,2.4-1.81,9.12,9.12,0,0,1,5.3-1c.35.05.66.06.93.13l.69.17A2.63,2.63,0,0,1,486.39,417.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.93,393.85s-.09.07-.28.17l-.84.46c-.73.39-1.78,1-3.05,1.72s-2.76,1.7-4.35,2.83a36.55,36.55,0,0,0-4.86,4.07,12.53,12.53,0,0,0-2,2.57c-.49.95-1,1.86-1.4,2.74a48.16,48.16,0,0,0-2.08,4.75,29.2,29.2,0,0,0-1,3.34c-.19.8-.26,1.26-.29,1.25a2.75,2.75,0,0,1,0-.33c0-.22.08-.54.16-.94a24.85,24.85,0,0,1,.94-3.39,45.15,45.15,0,0,1,2-4.79c.43-.88.9-1.8,1.38-2.75a12.74,12.74,0,0,1,2-2.64,35.47,35.47,0,0,1,4.91-4.08c1.6-1.13,3.11-2.05,4.4-2.79s2.35-1.29,3.09-1.65l.87-.41A1.06,1.06,0,0,1,493.93,393.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.88,416.59a3.2,3.2,0,0,1-.15-.64c-.09-.46-.2-1-.33-1.73a49.28,49.28,0,0,0-1.42-5.64,50.57,50.57,0,0,0-2.14-5.4c-.3-.64-.54-1.18-.74-1.61a3.63,3.63,0,0,1-.24-.6,2.56,2.56,0,0,1,.34.56c.2.36.48.9.81,1.57a37.7,37.7,0,0,1,3.58,11.08c.11.74.2,1.34.24,1.76A2.85,2.85,0,0,1,472.88,416.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.33,399.5a20.26,20.26,0,0,0-2.44-8.11,26.71,26.71,0,0,0-18.14-13.52l16.8,25,2.16,4.46A12.8,12.8,0,0,0,472.33,399.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.37,
    y: 448.83,
    width: 39.05,
    height: 6.92,
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.29 454.38 463.62 475.85 489.54 475.85 493.51 454.38 460.29 454.38",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.4,455.76c0,.07-8.81.14-19.67.14s-19.67-.07-19.67-.14,8.8-.14,19.67-.14S496.4,455.68,496.4,455.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.49,
    y: 347.45,
    width: 70.61,
    height: 116.31,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.5,383.17s0-.19,0-.53,0-.88,0-1.53c0-1.35,0-3.3-.05-5.79,0-5-.07-12.23-.11-21.08l.2.19-57.41.06c-.24.22.32-.31.27-.25h0v14.93c0,4.84,0,9.52,0,14l-.25-.23,41.23.11,11.88.06,3.19,0h.82l.29,0h-.26l-.8,0-3.13,0-11.83.07-41.39.11h-.26v-.23c0-4.46,0-9.14,0-14V354.26h0l.27-.25,57.41.06h.21v.19c-.05,8.9-.08,16.15-.11,21.19,0,2.48,0,4.42-.05,5.76,0,.63,0,1.13,0,1.48S702.5,383.17,702.5,383.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "662.78 354.32 665.7 357.01 681.8 357.01 684.81 354.32 662.78 354.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.5,416.9s0-.19,0-.54,0-.87,0-1.52c0-1.35,0-3.3-.05-5.79,0-5-.07-12.23-.11-21.08l.2.19-57.41.06c-.24.22.32-.31.27-.25h0v14.93c0,4.84,0,9.52,0,14l-.25-.23,41.23.11,11.88.06,3.19,0h.82l.29,0h-.26l-.8,0-3.13,0-11.83.07-41.39.11h-.26v-.23c0-4.46,0-9.14,0-14V388h0l.27-.25,57.41.06h.21V388c-.05,8.9-.08,16.15-.11,21.19,0,2.48,0,4.41-.05,5.76,0,.63,0,1.13,0,1.48S702.5,416.9,702.5,416.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "662.78 388.05 665.7 390.74 681.8 390.74 684.81 388.05 662.78 388.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.5,450.63s0-.19,0-.54,0-.87,0-1.52c0-1.35,0-3.3-.05-5.79,0-5-.07-12.23-.11-21.08l.2.19-57.41.06c-.24.22.32-.31.27-.25h0v14.93c0,4.84,0,9.52,0,14l-.25-.23,41.23.11,11.88.06,3.19,0h.82l.29,0h-.26l-.8,0-3.13,0-11.83.07-41.39.11h-.26v-.23c0-4.46,0-9.14,0-14V421.72h0l.27-.25,57.41.06h.21v.19c-.05,8.9-.08,16.15-.11,21.19,0,2.48,0,4.41-.05,5.76,0,.63,0,1.13,0,1.48S702.5,450.63,702.5,450.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "662.78 421.78 665.7 424.46 681.8 424.46 684.81 421.78 662.78 421.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.75,469.83a6.07,6.07,0,1,1-6.07-6.08A6.07,6.07,0,0,1,652.75,469.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.42,469.83a6.07,6.07,0,1,1-6.07-6.08A6.07,6.07,0,0,1,706.42,469.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.68,347.86H683.25a3,3,0,0,1-3-3V320.09H703l-2.3,2.28v22.49A3,3,0,0,1,697.68,347.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.68,347.86a3.53,3.53,0,0,0,1.79-.69,3,3,0,0,0,1.08-2c0-.9,0-2,0-3.18,0-4.83-.06-11.61-.1-19.66v-.1l.07-.07,2.3-2.28.17.41-18.1,0h-4.63l.26-.26c0,6.16,0,12,0,17.27,0,2.63,0,5.13,0,7.46a2.82,2.82,0,0,0,1.55,2.55,2.9,2.9,0,0,0,1.45.31H685l9.31.08,2.51.05.65,0,.23,0a.6.6,0,0,1-.23,0l-.65,0-2.51,0L685,348h-1.52a3.34,3.34,0,0,1-1.62-.32,3.23,3.23,0,0,1-1.8-2.9c0-2.33,0-4.83,0-7.46,0-5.28,0-11.11,0-17.27v-.26h23.57l-.41.41-2.31,2.28.07-.17c0,8.05-.07,14.83-.09,19.66,0,1.2,0,2.25-.06,3.21a3.1,3.1,0,0,1-1.2,2.05,2.91,2.91,0,0,1-1.37.56A1.51,1.51,0,0,1,697.68,347.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.74,327.09a27.07,27.07,0,0,1-5.3,0,27.07,27.07,0,0,1,5.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.79,324.14a2.59,2.59,0,0,1-1.17.13,2.65,2.65,0,0,1-1.18-.13,2.93,2.93,0,0,1,1.18-.12A2.86,2.86,0,0,1,682.79,324.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.74,333a29.32,29.32,0,0,1-5.3,0,27.07,27.07,0,0,1,5.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.79,330a2.76,2.76,0,0,1-1.17.13,2.83,2.83,0,0,1-1.18-.13,2.83,2.83,0,0,1,1.18-.13A2.76,2.76,0,0,1,682.79,330Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.74,338.8a27.07,27.07,0,0,1-5.3,0,27.07,27.07,0,0,1,5.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.79,335.85a2.76,2.76,0,0,1-1.17.13,2.83,2.83,0,0,1-1.18-.13,2.83,2.83,0,0,1,1.18-.13A2.76,2.76,0,0,1,682.79,335.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.74,344.65a27.07,27.07,0,0,1-5.3,0,27.07,27.07,0,0,1,5.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.79,341.7a2.76,2.76,0,0,1-1.17.13,2.83,2.83,0,0,1-1.18-.13,2.93,2.93,0,0,1,1.18-.12A2.86,2.86,0,0,1,682.79,341.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.39,347.69H650a3,3,0,0,1-3-3V319.91h22.72l-2.3,2.29v22.48A3,3,0,0,1,664.39,347.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.39,347.69a3.5,3.5,0,0,0,1.79-.69,2.93,2.93,0,0,0,1.08-2c0-.91,0-2,0-3.19,0-4.82,0-11.61-.09-19.65v-.1l.07-.07,2.29-2.29.17.41-18.09,0H647l.25-.26c0,6.17,0,12,0,17.27q0,4,0,7.47a2.82,2.82,0,0,0,1.55,2.55,3,3,0,0,0,1.45.3h1.52l9.31.08,2.52.05.65,0,.22,0-.22,0-.65,0-2.52,0-9.31.08h-1.52a3.24,3.24,0,0,1-1.62-.33,3.2,3.2,0,0,1-1.79-2.89q0-3.51,0-7.47c0-5.28,0-11.1,0-17.27v-.26h4.89l18.09,0h.59l-.42.41-2.3,2.28.07-.16c0,8-.08,14.83-.1,19.65,0,1.2,0,2.26-.06,3.21a3,3,0,0,1-1.2,2.05,3,3,0,0,1-1.37.57A2,2,0,0,1,664.39,347.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.46,326.92a27.07,27.07,0,0,1-5.3,0,27.07,27.07,0,0,1,5.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.51,324a2.83,2.83,0,0,1-1.18.13,2.76,2.76,0,0,1-1.17-.13,2.76,2.76,0,0,1,1.17-.13A2.83,2.83,0,0,1,649.51,324Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.46,332.77a27.07,27.07,0,0,1-5.3,0,27.07,27.07,0,0,1,5.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.51,329.82a2.83,2.83,0,0,1-1.18.13,2.76,2.76,0,0,1-1.17-.13,2.86,2.86,0,0,1,1.17-.12A2.93,2.93,0,0,1,649.51,329.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.46,338.62a27.07,27.07,0,0,1-5.3,0,29.32,29.32,0,0,1,5.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.51,335.68a2.93,2.93,0,0,1-1.18.12,2.86,2.86,0,0,1-1.17-.12,2.76,2.76,0,0,1,1.17-.13A2.83,2.83,0,0,1,649.51,335.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.46,344.48a29.32,29.32,0,0,1-5.3,0,27.07,27.07,0,0,1,5.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.51,341.53a2.83,2.83,0,0,1-1.18.13,2.76,2.76,0,0,1-1.17-.13,2.76,2.76,0,0,1,1.17-.13A2.83,2.83,0,0,1,649.51,341.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.38,309.1h0a.79.79,0,0,0,.78.79h1.4V324.1l-8.58,19a3.26,3.26,0,0,0,3,4.59h17a3.26,3.26,0,0,0,3-4.6l-8.91-19.65V310h1.27a.83.83,0,0,0,.83-.83h0a.83.83,0,0,0-.83-.82h-8.16A.78.78,0,0,0,670.38,309.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.38,309.1a.41.41,0,0,1,0-.23.77.77,0,0,1,.43-.53,3.44,3.44,0,0,1,1.11-.09l1.51,0,4.16,0h1.27a3.42,3.42,0,0,1,.7,0,.91.91,0,0,1,.61.49,1,1,0,0,1-.56,1.38,2.8,2.8,0,0,1-.8.05h-.77l.17-.17c0,3.8,0,8.38,0,13.52l0-.09,6.09,13.36L686,340.4c.28.61.56,1.23.85,1.85a5.63,5.63,0,0,1,.66,2,3.52,3.52,0,0,1-2.36,3.51,3.63,3.63,0,0,1-1.13.2H667.57a6.15,6.15,0,0,1-1.46-.1,3.52,3.52,0,0,1-2.27-1.8,3.46,3.46,0,0,1-.16-2.83c.35-.85.73-1.63,1.08-2.43,2.89-6.35,5.47-12.05,7.63-16.8l0,.07c.06-6.57.09-11.48.11-14.21l.08.07-1.17,0a1,1,0,0,1-.79-.24c-.31-.35-.22-.61-.22-.6a.9.9,0,0,0,.27.54.92.92,0,0,0,.74.19l1.17,0h.07v.08c0,2.73.06,7.64.11,14.21v0l0,0L665.2,341c-.35.79-.74,1.61-1.06,2.41a3,3,0,0,0,.14,2.42,3.05,3.05,0,0,0,2,1.54,5.28,5.28,0,0,0,1.34.08H684a3.07,3.07,0,0,0,1-.17,3,3,0,0,0,2-3,5.19,5.19,0,0,0-.62-1.85q-.42-.95-.84-1.86L683.88,337c-2.15-4.79-4.18-9.28-6-13.38l0,0v-.05c0-5.14,0-9.72.06-13.52v-.16h.16a11.56,11.56,0,0,0,1.47,0,.68.68,0,0,0,.4-.95.67.67,0,0,0-.42-.35,4.16,4.16,0,0,0-.63,0H677.6l-4.16,0-1.51,0a3.85,3.85,0,0,0-1.07.05A.83.83,0,0,0,670.38,309.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graphic-2--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.9,221.73H299.74a19.22,19.22,0,0,1-19.19-19.2V37.16A19.22,19.22,0,0,1,299.74,18H548.9a19.22,19.22,0,0,1,19.2,19.2V202.53A19.22,19.22,0,0,1,548.9,221.73ZM299.74,19a18.22,18.22,0,0,0-18.19,18.2V202.53a18.21,18.21,0,0,0,18.19,18.2H548.9a18.21,18.21,0,0,0,18.2-18.2V37.16A18.22,18.22,0,0,0,548.9,19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.4,132.67c.09.11-5,4.62-11.31,10.07s-11.56,9.77-11.65,9.66,5-4.61,11.31-10.06S524.31,132.57,524.4,132.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.22,133.37a1.56,1.56,0,1,1-1.56-1.55A1.56,1.56,0,0,1,525.22,133.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.29,115.55h-26a.84.84,0,0,1-.83-.83h0a.84.84,0,0,1,.83-.84h26a.84.84,0,0,1,.83.84h0A.83.83,0,0,1,552.29,115.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.29,119.85h-26a.84.84,0,0,1-.83-.83h0a.83.83,0,0,1,.83-.83h26a.83.83,0,0,1,.83.83h0A.83.83,0,0,1,552.29,119.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.23,124.44H526.29a.83.83,0,0,1-.83-.83h0a.83.83,0,0,1,.83-.83h11.94a.83.83,0,0,1,.83.83h0A.83.83,0,0,1,538.23,124.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.25,92.81a18.51,18.51,0,1,1-7.77-25A18.51,18.51,0,0,1,359.25,92.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.15,55h0a3.69,3.69,0,0,1-1.61,5L353.41,83a3.69,3.69,0,0,1-5-1.61h0a3.68,3.68,0,0,1,1.61-4.95l45.14-23A3.68,3.68,0,0,1,400.15,55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.6,
    cy: 61.48,
    r: 24.72,
    transform: "translate(-4.61 70.12) rotate(-9.97)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.46,
    cy: 166.45,
    r: 16.7,
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.06,137.33h0a4.22,4.22,0,0,1,5.85-1.27l31.15,20a4.23,4.23,0,0,1,1.26,5.85h0a4.24,4.24,0,0,1-5.85,1.27l-31.14-20A4.23,4.23,0,0,1,444.06,137.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.8,79.83a20.25,20.25,0,1,1-22.7-17.46A20.25,20.25,0,0,1,514.8,79.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.76,119.67h0a5.15,5.15,0,0,1-6.93-2.2l-22-42.39a5.14,5.14,0,0,1,2.2-6.93h0a5.14,5.14,0,0,1,6.93,2.2l22,42.39A5.15,5.15,0,0,1,429.76,119.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.25,121.1h0a5.13,5.13,0,0,1,.95-7.2l37.91-29a5.14,5.14,0,0,1,7.21.95h0a5.15,5.15,0,0,1-1,7.21l-37.9,29A5.13,5.13,0,0,1,444.25,121.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.77,
    cy: 125.62,
    r: 35.4,
    transform: "translate(210.82 519.41) rotate(-76.34)",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.63,98c-2.17-.9-5.92-.5-8.92.76a29,29,0,0,0-13.91,38.66,9.16,9.16,0,0,0,3,3.93,4,4,0,0,0,4.67-.06c1.87-1.68,1-4.68.39-7.13a20.76,20.76,0,0,1,9.84-22.41,59.78,59.78,0,0,0,5.82-3.09c1.79-1.27,3.29-3.25,3.22-5.44C435.69,100.88,433.8,98.91,431.63,98Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.87,41.62c-1.48-.61-4-.34-6.07.52a19.72,19.72,0,0,0-9.47,26.32,6.28,6.28,0,0,0,2.06,2.67,2.7,2.7,0,0,0,3.18,0c1.28-1.14.67-3.19.26-4.85A14.15,14.15,0,0,1,392.54,51a40.41,40.41,0,0,0,4-2.1,4.64,4.64,0,0,0,2.19-3.71A4.33,4.33,0,0,0,395.87,41.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M459.54,140a10.64,10.64,0,0,1,.79-1.43,29.63,29.63,0,0,0,1.9-4,28.22,28.22,0,0,0-3.7-27.53,30.41,30.41,0,0,0-2.89-3.34,15.32,15.32,0,0,1-1.14-1.16s.13.07.35.24a10.72,10.72,0,0,1,.93.77,25.61,25.61,0,0,1,3,3.26,27.59,27.59,0,0,1,3.75,27.89,25.29,25.29,0,0,1-2.07,3.95,11.48,11.48,0,0,1-.69,1A1.29,1.29,0,0,1,459.54,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.71,70c-.08-.05.64-1.08,1.41-2.93a19.15,19.15,0,0,0,1.05-3.34,20.93,20.93,0,0,0,.45-4.26,21.51,21.51,0,0,0-.47-4.25,19.41,19.41,0,0,0-1.06-3.34c-.79-1.84-1.51-2.87-1.43-2.93s.23.23.56.69a7.37,7.37,0,0,1,.56.87,12.36,12.36,0,0,1,.64,1.22,17.33,17.33,0,0,1,1.2,3.38,20.35,20.35,0,0,1,.52,4.36,19.86,19.86,0,0,1-.5,4.37,17.63,17.63,0,0,1-1.18,3.38,11.32,11.32,0,0,1-.64,1.22,6.06,6.06,0,0,1-.55.87C416.94,69.79,416.74,70,416.71,70Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graphic-1--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.47,
    y: 68.81,
    width: 125.87,
    height: 108.42,
    rx: 7.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.66,177.23s.41,0,1.17-.13a7.61,7.61,0,0,0,6.22-5.76,15,15,0,0,0,.21-3.55c0-1.27,0-2.63,0-4.07,0-11.54-.05-28.2-.09-48.8,0-10.3,0-21.59,0-33.7-.16-3,.58-6.28-1.25-8.86a7.48,7.48,0,0,0-3.53-2.82,11.81,11.81,0,0,0-4.66-.5h-19.9l-88.62,0a7.42,7.42,0,0,0-7.42,7.08c0,3.87,0,7.73,0,11.55v22.61c0,14.82,0,29.12,0,42.75v15a21.25,21.25,0,0,0,.06,2.41,7.38,7.38,0,0,0,.66,2.25,7.59,7.59,0,0,0,3.15,3.34,8.34,8.34,0,0,0,2.16.78A12.47,12.47,0,0,0,58,177h9.24l33.7,0,48.79.08,13.27.05,3.45,0,1.17,0s-.39,0-1.17,0l-3.45,0-13.27.05-48.79.08-33.7,0H58a12.12,12.12,0,0,1-2.39-.14,8.62,8.62,0,0,1-2.29-.83,7.93,7.93,0,0,1-4-5.92,22.85,22.85,0,0,1-.07-2.47v-5q0-5,0-10.08c0-13.63,0-27.93,0-42.75,0-7.41,0-15,0-22.61q0-5.74,0-11.58a7.95,7.95,0,0,1,7.94-7.57l88.62,0h19.9c.81,0,1.6,0,2.42,0a7.58,7.58,0,0,1,2.4.52,8,8,0,0,1,3.74,3,8.11,8.11,0,0,1,1.32,4.53c0,1.54,0,3.07,0,4.58,0,12.11,0,23.4,0,33.7,0,20.6-.06,37.26-.08,48.8,0,1.44,0,2.8,0,4.07a14.76,14.76,0,0,1-.24,3.58,7.83,7.83,0,0,1-3.15,4.55,7.74,7.74,0,0,1-3.21,1.24,5.66,5.66,0,0,1-.88.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.92,
    y: 55.7,
    width: 59.11,
    height: 50.92,
    rx: 7.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.35,106.61a10.26,10.26,0,0,0,2.06-.34,7.63,7.63,0,0,0,4.54-3.62,7.88,7.88,0,0,0,1-4.14c0-1.59,0-3.32,0-5.18,0-3.72,0-8,0-12.63s0-9.8,0-15.3a14.44,14.44,0,0,0-.31-4.11A7.46,7.46,0,0,0,240.4,56a16.38,16.38,0,0,0-2.24-.09h-2.3l-40.25,0a7.41,7.41,0,0,0-7.29,6,11.82,11.82,0,0,0-.14,2.54v7.67c0,6.73,0,13.23,0,19.41,0,1.55,0,3.08,0,4.59V98.4a9,9,0,0,0,.18,2.15,7.44,7.44,0,0,0,5.49,5.62,17.65,17.65,0,0,0,4,.24h3.91l7.35,0,22.16.08,6,0,1.56,0,.54,0-.54,0-1.56,0-6,0-22.16.08H195.79a8.6,8.6,0,0,1-2.07-.24,7.88,7.88,0,0,1-5.84-5.94,9.46,9.46,0,0,1-.19-2.25c0-.74,0-1.49,0-2.24V91.57c0-6.18,0-12.68,0-19.41V64.49a13.12,13.12,0,0,1,.15-2.64,7.94,7.94,0,0,1,7.8-6.41l40.25,0h2.3a15,15,0,0,1,2.31.09,7.85,7.85,0,0,1,4.11,1.9,8,8,0,0,1,2.35,3.72,8.21,8.21,0,0,1,.32,2.14V65.4c0,5.5,0,10.62,0,15.3s0,8.91,0,12.63c0,1.86,0,3.59,0,5.18a8,8,0,0,1-1,4.24,7.71,7.71,0,0,1-4.69,3.62,6.8,6.8,0,0,1-1.56.24C239.53,106.62,239.35,106.61,239.35,106.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.62,87.17h-26a.83.83,0,0,1-.83-.83h0a.83.83,0,0,1,.83-.83h26a.83.83,0,0,1,.83.83h0A.84.84,0,0,1,149.62,87.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.62,91.47h-26a.83.83,0,0,1-.83-.83h0a.83.83,0,0,1,.83-.83h26a.83.83,0,0,1,.83.83h0A.83.83,0,0,1,149.62,91.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,96.06H123.62a.83.83,0,0,1-.83-.83h0a.83.83,0,0,1,.83-.83h11.93a.83.83,0,0,1,.83.83h0A.83.83,0,0,1,135.55,96.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.12,150.15h-26a.83.83,0,0,1-.83-.83h0a.83.83,0,0,1,.83-.83h26a.83.83,0,0,1,.83.83h0A.83.83,0,0,1,103.12,150.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.12,154.45h-26a.83.83,0,0,1-.83-.83h0a.83.83,0,0,1,.83-.83h26a.83.83,0,0,1,.83.83h0A.83.83,0,0,1,103.12,154.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.05,159H77.12a.83.83,0,0,1-.83-.83h0a.83.83,0,0,1,.83-.83H89.05a.83.83,0,0,1,.83.83h0A.83.83,0,0,1,89.05,159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,105a.82.82,0,0,1,.21.14c.14.1.33.26.6.45a19.81,19.81,0,0,0,2.43,1.54,20,20,0,0,0,4.2,1.71,18.68,18.68,0,0,0,6,.64,58.79,58.79,0,0,0,7.24-1A30.73,30.73,0,0,1,101,108a28.19,28.19,0,0,1,9,2.38,25.54,25.54,0,0,1,13.36,14.28,24.13,24.13,0,0,1,1.58,9.15c0,3-.38,5.77-.39,8.4a20,20,0,0,0,1.1,7.16,19.35,19.35,0,0,0,2.87,5.26,19,19,0,0,0,3.14,3.26c.47.42.94.72,1.33,1l1,.65.65.37.22.14-.23-.11-.67-.35c-.29-.16-.63-.38-1-.63s-.87-.58-1.35-1a19.38,19.38,0,0,1-3.21-3.25,19.59,19.59,0,0,1-2.93-5.29,20.14,20.14,0,0,1-1.15-7.23c0-2.65.34-5.45.37-8.4a24,24,0,0,0-1.58-9,25.68,25.68,0,0,0-5.21-8.36,25.28,25.28,0,0,0-8-5.75,27.66,27.66,0,0,0-8.89-2.37,29.94,29.94,0,0,0-8.33.44,59.58,59.58,0,0,1-7.27,1,18.55,18.55,0,0,1-6-.69,20.16,20.16,0,0,1-4.22-1.76,19.44,19.44,0,0,1-2.41-1.6c-.26-.2-.45-.37-.58-.47Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.43,85.44a31.26,31.26,0,0,1,2.84,2.76,30.67,30.67,0,0,1,2.93,3.62,17.84,17.84,0,0,1,2.63,5.56,10.91,10.91,0,0,1,.31,1.74c0,.6.07,1.21.07,1.83,0,1.25,0,2.54,0,3.88,0,2.68,0,5.55.11,8.56a27.32,27.32,0,0,0,2,9.15,24.3,24.3,0,0,0,5.57,8.33,22.3,22.3,0,0,0,8.58,5.14,19.9,19.9,0,0,0,9.28.76c3-.48,5.69-1.43,8.33-2a20.2,20.2,0,0,1,3.87-.46,18.8,18.8,0,0,1,3.58.3,19.3,19.3,0,0,1,5.78,2.12,18.13,18.13,0,0,1,5.67,5l.43.63.14.22a1.75,1.75,0,0,1-.16-.2l-.46-.61a17.9,17.9,0,0,0-2-2.17,18.2,18.2,0,0,0-3.73-2.71,19.06,19.06,0,0,0-5.74-2.06,18.33,18.33,0,0,0-3.54-.29,20.79,20.79,0,0,0-3.82.48c-2.62.53-5.34,1.49-8.34,2a20.17,20.17,0,0,1-9.41-.75,22.55,22.55,0,0,1-8.69-5.21,24.46,24.46,0,0,1-5.64-8.43,27.43,27.43,0,0,1-2-9.25c-.12-3-.09-5.88-.08-8.57,0-1.34,0-2.63,0-3.88,0-.62,0-1.23-.06-1.81a11.73,11.73,0,0,0-.29-1.71,17.65,17.65,0,0,0-2.57-5.52,32,32,0,0,0-2.87-3.63c-.86-1-1.56-1.65-2-2.12l-.54-.53Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.09,100c.06.05-1.63,2.28-3.78,5a61.41,61.41,0,0,1-4,4.8c-.06,0,1.63-2.28,3.78-5S95,99.91,95.09,100Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.46,94.44c.06.06-2.91,3.31-6.63,7.27S80,108.83,80,108.77s2.91-3.31,6.63-7.27S93.4,94.38,93.46,94.44Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.22,89.36c.06.06-3.54,3.93-8,8.66s-8.21,8.51-8.27,8.45,3.55-3.93,8-8.66S90.16,89.3,90.22,89.36Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.28,128.47c0,.06-2,2.05-4.71,4.45s-4.85,4.29-4.9,4.23,2-2.06,4.7-4.45S124.22,128.41,124.28,128.47Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.22,120.9a3.25,3.25,0,0,1-.48.58L119.32,123c-1.21,1.23-2.92,2.9-4.86,4.69s-3.75,3.36-5.07,4.46c-.67.56-1.21,1-1.59,1.29a3.36,3.36,0,0,1-.61.44,3.72,3.72,0,0,1,.53-.52l1.53-1.37c1.29-1.14,3.07-2.73,5-4.52s3.66-3.43,4.91-4.62l1.48-1.41A5.94,5.94,0,0,1,121.22,120.9Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.68,115.14a4.82,4.82,0,0,1-.62.58c-.46.38-1,.88-1.74,1.48-1.47,1.26-3.48,3-5.65,5s-4.07,3.87-5.44,5.23L101.61,129a4.83,4.83,0,0,1-.62.57,4.27,4.27,0,0,1,.53-.65c.36-.4.89-1,1.56-1.68,1.33-1.4,3.22-3.29,5.39-5.29s4.21-3.73,5.71-4.95c.76-.61,1.37-1.09,1.8-1.41A5,5,0,0,1,116.68,115.14Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.28,111.35a2.78,2.78,0,0,1-.44.48l-1.27,1.23c-1.08,1-2.56,2.46-4.16,4.07s-3,3.09-4.06,4.17c-.48.5-.89.93-1.23,1.27a3.6,3.6,0,0,1-.47.45s.12-.2.39-.52.66-.78,1.15-1.34c1-1.12,2.4-2.63,4-4.24s3.11-3,4.23-4c.55-.5,1-.89,1.33-1.16A2.86,2.86,0,0,1,109.28,111.35Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.55,108.36c.06,0-1.68,1.84-3.87,4a50.3,50.3,0,0,1-4.09,3.78,50.36,50.36,0,0,1,3.88-4A53.39,53.39,0,0,1,103.55,108.36Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.31,134.43s-.12.17-.39.43L133.79,136,130,139.62l-3.74,3.68-1.14,1.11c-.28.26-.43.4-.45.38a2.91,2.91,0,0,1,.36-.46l1.08-1.17c.92-1,2.21-2.32,3.68-3.75s2.83-2.69,3.83-3.59l1.2-1A2.13,2.13,0,0,1,135.31,134.43Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,136.94c.06.06-3.42,3.56-7.77,7.81s-7.93,7.66-8,7.6,3.43-3.56,7.78-7.81S142.44,136.88,142.49,136.94Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,140.32c.06.05-3.54,3.86-8,8.5s-8.19,8.36-8.24,8.3,3.54-3.86,8-8.5S146.74,140.26,146.8,140.32Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.84,
    cy: 108.91,
    r: 2.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.68,94.53a70,70,0,0,1-4.53,7.06,70.54,70.54,0,0,1-5,6.76,68,68,0,0,1,4.53-7.06A65.35,65.35,0,0,1,116.68,94.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.29,
    cy: 136.65,
    r: 2.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.35,
    cy: 131.31,
    r: 2.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.08,
    cy: 106.48,
    r: 2.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46,148.72A53.87,53.87,0,0,1,119,142.8a53.46,53.46,0,0,1,5-5.59,53.28,53.28,0,0,1-4.55,5.92A54.12,54.12,0,0,1,114.46,148.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,92.43c-6.85,4.46-15.69,3-19.75-3.19s-1.79-14.9,5.07-19.36,15.69-3,19.75,3.19S232.2,88,225.34,92.43Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.89,88.39a9.65,9.65,0,0,0,7.68-.27,11.53,11.53,0,0,0,5.51-5c.46-.82.78-1.91.16-2.62a1.8,1.8,0,0,0-2.3-.08,6.78,6.78,0,0,0-1.6,1.92,9.4,9.4,0,0,1-2.91,2.91,5.07,5.07,0,0,1-4,.59c-.89-.28-1.79-.87-2.69-.61a1.54,1.54,0,0,0-1.09,1.49,1.9,1.9,0,0,0,1.23,1.64"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.49,75.78a4.25,4.25,0,0,0,2.58-1.11,1.76,1.76,0,0,0-.13-2.51l0,0a4.14,4.14,0,0,0-1.38-.6c-3.22-.73-6.39.74-8.82,3.15a4.31,4.31,0,0,0-1,1.5,2,2,0,0,0,.18,1.76c.65.91,2.08.8,3.06.25s1.76-1.42,2.79-1.87A10.46,10.46,0,0,1,218.49,75.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.58,76.54a1.71,1.71,0,0,1,.1.28,7.17,7.17,0,0,1,.19.81,8.82,8.82,0,0,1,0,3.07,9.63,9.63,0,0,1-1.82,4.16,11.5,11.5,0,0,1-4.31,3.53,9.53,9.53,0,0,1-2.78.83,9.75,9.75,0,0,1-2.71-.07,8.92,8.92,0,0,1-4.2-1.73,7.74,7.74,0,0,1-2-2.33,4.56,4.56,0,0,1-.37-.75.83.83,0,0,1-.1-.27s.18.36.57,1a8.12,8.12,0,0,0,2,2.23,8.84,8.84,0,0,0,4.11,1.62,9.23,9.23,0,0,0,2.63.05,9.09,9.09,0,0,0,2.7-.81,11.56,11.56,0,0,0,4.22-3.42,9.69,9.69,0,0,0,1.83-4,9.17,9.17,0,0,0,.08-3C226.66,76.94,226.55,76.55,226.58,76.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.36,84.5c-.05,0,.39-.67.83-1.81a10.76,10.76,0,0,0,.65-4.68,10.62,10.62,0,0,0-1.49-4.48c-.63-1-1.18-1.59-1.14-1.63s.17.11.41.36a8.88,8.88,0,0,1,.91,1.16,9.93,9.93,0,0,1,.85,9.35,9.06,9.06,0,0,1-.69,1.3C226.5,84.36,226.38,84.51,226.36,84.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.64,88.28c0-.08.57-.43,1.26-.94a9,9,0,0,1,1.26-.93c.06,0-.37.64-1.09,1.17A3,3,0,0,1,222.64,88.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.58,76s.06-.15.21-.4a8.1,8.1,0,0,1,.74-1,12,12,0,0,1,3.09-2.57,12.39,12.39,0,0,1,3.75-1.45,9.78,9.78,0,0,1,1.21-.17,1.51,1.51,0,0,1,.45,0c0,.05-.63.12-1.61.36a14,14,0,0,0-6.74,4C209,75.52,208.62,76,208.58,76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.8,106.61a2.89,2.89,0,0,1,.06.66c0,.49,0,1.11,0,1.89,0,1.7,0,4.06.08,6.94s.07,6.4,0,10.32a5.78,5.78,0,0,1-3.69,4.78,8.43,8.43,0,0,1-3.26.37h-3.32l-22.9-.08-7-.08-1.88,0a2.56,2.56,0,0,1-.66-.05,2.56,2.56,0,0,1,.66-.05l1.88,0,7-.08,22.9-.08h3.32a8,8,0,0,0,3.08-.33,5.28,5.28,0,0,0,3.39-4.35c.08-3.82.05-7.35.09-10.27s.06-5.24.08-6.94c0-.78,0-1.4.05-1.89A5,5,0,0,1,217.8,106.61Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.26,160.2v0a25.14,25.14,0,1,0-4.72-7.68l-2.61,7.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.26,160.19h-.46l-1.39-.05-5.49-.22h-.15l.05-.13c.7-2,1.57-4.48,2.56-7.33v.1a25,25,0,0,1-1.52-12.62,35.31,35.31,0,0,1,.77-3.64,28,28,0,0,1,1.39-3.64,25.06,25.06,0,0,1,4.67-6.84,25.35,25.35,0,0,1,35-1.48,25,25,0,0,1,5.34,6.51,26.29,26.29,0,0,1,2.84,7.66,25.58,25.58,0,0,1-1.72,15.18,25.5,25.5,0,0,1-8.87,10.65,25.23,25.23,0,0,1-21.32,3.36,24.82,24.82,0,0,1-6.86-3.21,24.13,24.13,0,0,1-3.7-3c-.39-.38-.67-.7-.85-.91a2.59,2.59,0,0,1-.28-.34h0a3.13,3.13,0,0,1,.32.3c.19.2.49.5.89.88a25.52,25.52,0,0,0,3.74,2.95,25,25,0,0,0,6.82,3.1A25,25,0,0,0,645,164a25.06,25.06,0,0,0,8.68-10.48,24.39,24.39,0,0,0,1.95-7.16,24,24,0,0,0-.29-7.73,25.8,25.8,0,0,0-2.79-7.5,24.56,24.56,0,0,0-5.23-6.38,24.85,24.85,0,0,0-38.91,8.11A28.58,28.58,0,0,0,607,136.4c-.27,1.22-.62,2.4-.77,3.58a24.83,24.83,0,0,0,1.41,12.46l0,.06,0,.05c-1,2.83-1.92,5.3-2.65,7.3l-.09-.15,5.4.36,1.43.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625,146.53a8.16,8.16,0,1,1,11.08-10.91h0a8.18,8.18,0,0,1-3.61,11A8.16,8.16,0,0,1,625,146.53Zm7.32-14a7.62,7.62,0,0,0-10.77,4.37,7.62,7.62,0,1,0,14-1.06A7.63,7.63,0,0,0,632.29,132.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.42,156h0a1,1,0,0,1-1.38-.38l-5-8.84a.18.18,0,0,1,.07-.24l1.16-.66a.18.18,0,0,1,.24.06l5.3,8.64A1,1,0,0,1,638.42,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.19,146.13a8.16,8.16,0,0,1,.1-14.52,8.17,8.17,0,0,1,11,3.6h0a8.17,8.17,0,0,1-11.07,10.92Zm7.31-14a7.61,7.61,0,0,0-10.33,10.18,7.62,7.62,0,1,0,13.6-6.87A7.63,7.63,0,0,0,632.5,132.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.6,155.84h0a.84.84,0,0,1-1.14-.31l-5.32-9.36,1.46-.83,5.32,9.36A.83.83,0,0,1,638.6,155.84Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.39,187.58c3.4-.41,8.71-2.05,12.5.45s14.7,25.61,14.7,25.61l-13.11,9.82L490.56,198a67.16,67.16,0,0,1-12.58-2.3,17.2,17.2,0,0,1-9.34-7.54s-3.35-6-.46-6.74c1.35-.33,2.32,1.51,3.2,2.93a15.3,15.3,0,0,0,2.15,2.73l2.91,2.32s-2.3-2.57-1.09-3.69,1.91-.75,3.59-.22S485.39,187.58,485.39,187.58Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.06,188.64a11.49,11.49,0,0,0-2.55,0c-1.57.19-3.62,1.13-6.1,1.47a15.88,15.88,0,0,1-6.33-.16,7.7,7.7,0,0,1-1.79-.72c-.4-.23-.59-.39-.57-.42a21.8,21.8,0,0,0,2.45.78,17.72,17.72,0,0,0,6.16,0c2.39-.32,4.48-1.21,6.13-1.32a5.93,5.93,0,0,1,1.94.1C492.85,188.49,493.07,188.61,493.06,188.64Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484,192.28a2.43,2.43,0,0,1-.74.21,10,10,0,0,1-2.08.12,11.46,11.46,0,0,1-6.4-2.4,15.23,15.23,0,0,1-2.57-2.77,3,3,0,0,0-2.42-1.29,1.45,1.45,0,0,0-1.28,1.17,1.77,1.77,0,0,0,.08.71s-.29-.19-.28-.73a1.58,1.58,0,0,1,.34-.88,1.65,1.65,0,0,1,1.09-.64,3.31,3.31,0,0,1,2.83,1.35,16.21,16.21,0,0,0,2.53,2.67,12,12,0,0,0,6.1,2.44C482.86,192.41,483.93,192.18,484,192.28Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.28,148.69a4.21,4.21,0,0,1-1.37-8.27,4.39,4.39,0,0,1,4.2-7.19,5.24,5.24,0,0,1,8.12-3.89,5.89,5.89,0,0,1,7.26.22,4.2,4.2,0,0,1,3.34,7.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.18,133.76l-.92,0a17.88,17.88,0,0,0-18.62,15.54c-1.12,8.6-2.26,18.11-2.43,22.74-.36,9.59,9.16,11.56,9.16,11.56L562,195l23.73-4.38,3.7-36.85C590.77,143.88,586.13,134.84,576.18,133.76Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.37,183.55A23.22,23.22,0,0,0,576,180.48s-3.45,6.92-13,5.58Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.81,159.22a1.37,1.37,0,0,0,1.26,1.45,1.31,1.31,0,0,0,1.47-1.16,1.38,1.38,0,0,0-1.25-1.45A1.32,1.32,0,0,0,558.81,159.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.47,154c.16.19,1.23-.52,2.71-.45s2.51.87,2.68.7-.07-.41-.53-.78a3.76,3.76,0,0,0-2.14-.77,3.63,3.63,0,0,0-2.16.58C558.56,153.65,558.39,154,558.47,154Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.55,159.78a1.38,1.38,0,0,0,1.25,1.45,1.33,1.33,0,0,0,1.48-1.17,1.38,1.38,0,0,0-1.25-1.45A1.32,1.32,0,0,0,571.55,159.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.93,155c.16.19,1.24-.53,2.71-.45s2.52.86,2.69.69-.08-.4-.53-.77a3.72,3.72,0,0,0-2.14-.78,3.64,3.64,0,0,0-2.17.58C573,154.64,572.85,155,572.93,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567,165.7a9.14,9.14,0,0,0-2.37-.55c-.37-.06-.72-.15-.77-.41a1.91,1.91,0,0,1,.3-1.11l1.26-2.81c1.74-4,3-7.29,2.87-7.36s-1.71,3.12-3.46,7.12l-1.21,2.82a2.25,2.25,0,0,0-.27,1.47.94.94,0,0,0,.59.58,2.37,2.37,0,0,0,.64.12A9.66,9.66,0,0,0,567,165.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.94,149.31c.17.38,1.45,0,3,.07s2.85.35,3,0c.07-.18-.18-.53-.73-.85a4.66,4.66,0,0,0-2.31-.61,4.55,4.55,0,0,0-2.28.58C572.1,148.78,571.86,149.13,571.94,149.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.7,148c.29.35,1.52.06,3,.12s2.69.36,3,0c.13-.16,0-.51-.57-.85a5.07,5.07,0,0,0-4.82-.12C558.76,147.46,558.57,147.8,558.7,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.78,144.9s2.83-5.87,5.79-7.13c3.59-1.52,4.91,2.4,8.29,1.63s6.81-2.23,10.1.52c3.59,3,1.74,4.91,1.76,9.17.08,17.29,3,22.32,4.29,14.25.14-.89,2.64-1.47,3.2-5.21.71-4.85,1.2-10.76.28-14.28-.77-3-2.34-5.06-5.21-7.42-4.53-3.74-11-4.14-15.4-3.92S557.75,137.37,557.78,144.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.41,163.05a2.6,2.6,0,0,1,2.93-2.37c1.78.26,3.72,1.37,3.42,5.06-.54,6.54-7,4.66-7,4.47S587.16,165.78,587.41,163.05Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.4,167.86s.1.09.29.2a1.15,1.15,0,0,0,.85.08,2.81,2.81,0,0,0,1.51-2.42,3.61,3.61,0,0,0-.19-1.66,1.32,1.32,0,0,0-.78-.94.59.59,0,0,0-.7.25c-.1.18-.07.31-.11.32s-.13-.12,0-.39a.66.66,0,0,1,.29-.38.82.82,0,0,1,.64-.12,1.63,1.63,0,0,1,1.11,1.11,3.9,3.9,0,0,1,.25,1.86,3,3,0,0,1-1.9,2.69,1.24,1.24,0,0,1-1-.26C588.39,168,588.37,167.87,588.4,167.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.91,150.34a6.23,6.23,0,0,1-2.84,1.15,2.14,2.14,0,0,1-2.29-1.62c-.06-.46.08-1-.2-1.35s-1-.34-1.56-.31c-1.91.1-4-2.11-4.43-4a1.71,1.71,0,0,1-2.31.36,6.24,6.24,0,0,1-1.51-1.48,2.69,2.69,0,0,0-2.19-1.24,6.69,6.69,0,0,1-1.44.25c-.86-.12-1.23-1.15-1.32-2s-.13-1.86-.84-2.36a3.44,3.44,0,0,0-2.34-.19c-.8.08-1.81-.16-2-.94a1.55,1.55,0,0,1,.36-1.17,4.25,4.25,0,0,1,5.09-1.36,5.76,5.76,0,0,1,10.62-.59,5.85,5.85,0,0,1,9.23,2.59,4.24,4.24,0,0,1,4.46,6.39,4,4,0,0,1,2.05,3.31c0,1.36-1.43,2.65-2.72,2.22a2.35,2.35,0,0,1-4.17,2.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.52,136v.12a2.51,2.51,0,0,0,0,.35,4.27,4.27,0,0,0,.42,1.29,4.65,4.65,0,0,0,1.37,1.62,4.35,4.35,0,0,0,2.65.9l-.11-.15a2.4,2.4,0,0,0,0,1.82,6.32,6.32,0,0,0,1,1.66,4.54,4.54,0,0,0,.69.79,2.39,2.39,0,0,0,1,.44,2.42,2.42,0,0,0,2.15-.65l-.24-.08a4.92,4.92,0,0,0,1.91,3.5,3.62,3.62,0,0,0,2.12.81,6.49,6.49,0,0,0,2.14-.36l-.17-.08a5.22,5.22,0,0,0,1.45,2.1,2.78,2.78,0,0,0,2.26.73,3.59,3.59,0,0,0,2.91-2.69l-.15.07a3.46,3.46,0,0,0,2.24.44,3.8,3.8,0,0,0,1.6-.62,3.52,3.52,0,0,0,.78-.77,1.58,1.58,0,0,0,.18-.33,3.8,3.8,0,0,1-1,1,3.54,3.54,0,0,1-1.56.56,3.26,3.26,0,0,1-2.11-.45l-.12-.08,0,.14a3.4,3.4,0,0,1-2.76,2.48,2.44,2.44,0,0,1-2-.69,4.94,4.94,0,0,1-1.37-2l0-.12-.13,0a6.48,6.48,0,0,1-2,.34,3.28,3.28,0,0,1-2-.76,4.61,4.61,0,0,1-1.81-3.3l0-.31-.22.23a2.1,2.1,0,0,1-1.89.57,2,2,0,0,1-.91-.38,4.71,4.71,0,0,1-.65-.74,6.12,6.12,0,0,1-1-1.59,2.16,2.16,0,0,1-.06-1.65l.06-.15H572a4.18,4.18,0,0,1-2.53-.82,4.52,4.52,0,0,1-1.38-1.54A5.34,5.34,0,0,1,567.52,136Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.11,170.75c0-.24,1.65.18,3.14-.89s1.76-2.81,2-2.76.21.46,0,1.18a4.1,4.1,0,0,1-1.57,2.33,3.61,3.61,0,0,1-2.6.65C567.42,171.14,567.08,170.86,567.11,170.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.67,438l5.86,20.28S553.88,471,554.6,474.87l39.72-9.94-7.82-32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.38,453.46A1.67,1.67,0,0,1,586,455a1.61,1.61,0,0,1-1.54,1.59,1.78,1.78,0,0,1-1.67-1.68,1.68,1.68,0,0,1,1.79-1.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.32,464.93l-.91-3.19-37.75,10.72s-1.57,1.21-1.06,2.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M571.83,458.21c.06.2,1,0,2.16.43s1.82,1.07,2,.95-.41-1.17-1.76-1.61S571.75,458.05,571.83,458.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.1,461c0,.2.92.32,1.79,1s1.27,1.48,1.46,1.42,0-1.18-1.05-2S568.05,460.79,568.1,461Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567,466.56c.18,0,.21-1-.55-2s-1.78-1.13-1.82-.95.66.61,1.28,1.39S566.78,466.59,567,466.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571,453.45c.13.15,1-.34,2.06-.54s2.06-.07,2.12-.26-.94-.68-2.25-.42S570.88,453.32,571,453.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.6,442.75l.92,21.09s-21.12,8-21.33,11.93l40.95-.32-.09-32.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.17,462a1.68,1.68,0,0,1,1.17,1.9,1.6,1.6,0,0,1-1.87,1.18,1.76,1.76,0,0,1-1.23-2,1.67,1.67,0,0,1,2.08-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.14,475.45l-.14-3.32-39.21,1.55s-1.82.81-1.6,2.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M580.86,463.63c0,.2,1,.29,2,.92s1.52,1.47,1.71,1.39-.13-1.23-1.34-2S580.81,463.45,580.86,463.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.57,465.44c0,.2.83.53,1.51,1.37s.89,1.74,1.09,1.73.32-1.15-.55-2.18S576.58,465.25,576.57,465.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.18,470.6c.18,0,.45-1-.07-2.05s-1.46-1.52-1.55-1.35.5.75.92,1.65S574,470.59,574.18,470.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.18,458.81c.08.18,1-.11,2.13,0s2,.42,2.12.25-.75-.88-2.09-.94S581.08,458.65,581.18,458.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.93,288.46v16.67l-4.48,65s2.79,31.5,4.5,49.29c1.49,15.45-.94,42.35-.94,42.35H578.94L569.62,372l-5.79-55.94L553.76,290.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.13,291.08l-.79,85.37a28.76,28.76,0,0,0,1.95,10.69l24.36,62.69,1.22,4.08,15.57-3.76L573.86,289.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.9,316.73a2.21,2.21,0,0,0,0,.38c0,.27,0,.64,0,1.11,0,1,.08,2.42.13,4.24.11,3.69.37,9,.75,15.62.78,13.17,2.25,31.35,4.54,51.36s4.74,38.08,6.55,51.15c.93,6.51,1.68,11.79,2.2,15.47.26,1.81.47,3.22.62,4.2.07.47.13.83.17,1.1s.07.37.07.37a2.16,2.16,0,0,0,0-.38c0-.27-.07-.63-.13-1.1-.12-1-.3-2.4-.53-4.21-.48-3.69-1.18-9-2-15.5-1.73-13.08-4.16-31.15-6.41-51.16s-3.81-38.16-4.68-51.33c-.42-6.58-.73-11.91-.9-15.59-.09-1.83-.17-3.25-.22-4.25,0-.46,0-.83-.07-1.1A2.28,2.28,0,0,0,563.9,316.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.25,294.07a1.34,1.34,0,1,0,1.34-1.35A1.34,1.34,0,0,0,562.25,294.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.34,306.72a8.43,8.43,0,0,0,1.83-1.72,20.5,20.5,0,0,0,3.28-5.13,20.13,20.13,0,0,0,1.64-5.86,8.51,8.51,0,0,0,.07-2.52,23.79,23.79,0,0,0-.41,2.47,24,24,0,0,1-4.84,10.82C540,306,539.28,306.66,539.34,306.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.86 191.29 536.94 200.54 529.57 207.77 516.47 227.19 549.43 224.45 550.2 232.87 559.86 191.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.41,184.16,593,190s19.51,9.39,19.43,10.54c0,0-5.47,33.21-5.71,65.13,0,0,5.67,25.89,5.91,31.22.64,14,2.45,80.34,2.45,80.34l-78.12,2.14,4.1-97.89-1.35-63.29,17.65-26,4.14-3.95,8.35,7.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.82,213.58l-8-17.56-18.34,7.31L495,221.66c2.67,7.65,5.74,15.83,10.92,17,8.13,1.87,43.55-14.23,43.55-14.23L556,197.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M608.21,271.43a19,19,0,0,0-4.47-2.45c-9.18-4.15-17.25-10.37-26-15.39s-18.66-8.93-28.66-7.74l-8.42,10.53s2.1,3.69,4.94,3.95a34.26,34.26,0,0,0,7.3.06c2.83-.25,5.88-.09,8.24,1.5s3.78,4.64,5.94,6.72c2.59,2.51,6.22,3.57,9.69,4.54l22.13,6.2c2.21.62,4.51,1.25,6.78.87s4.48-2.08,4.67-4.37A5.38,5.38,0,0,0,608.21,271.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M594.18,217.77l4.62,31.9-20.18-8-7.85,21.65s25.49,11.2,38.63,13.16c6.36.94,15.25-6.83,14.62-14.7-1.65-20.42-7.47-56.08-7.47-56.08s-4.14-8.48-11.19-7.51a10.65,10.65,0,0,0-6.28,3.49C593.51,207.46,594.18,217.77,594.18,217.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604,258.42a24.76,24.76,0,0,0-2.06-4.79,25.75,25.75,0,0,0-3.4-4,10.91,10.91,0,0,1,5.46,8.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.55,205.67s0,.17.11.5.15.84.26,1.48c.22,1.32.53,3.22.94,5.67.79,4.94,1.9,12.09,3.14,20.94.62,4.43,1.27,9.28,1.9,14.5.3,2.61.61,5.31.89,8.1.15,1.39.26,2.81.4,4.24a20.18,20.18,0,0,1,.06,2.21,12.88,12.88,0,0,1-.4,2.2,14,14,0,0,1-.77,2.14,15.54,15.54,0,0,1-1.13,2,19.11,19.11,0,0,1-1.4,1.85,21.43,21.43,0,0,1-1.66,1.64,15.77,15.77,0,0,1-4,2.58,10.62,10.62,0,0,1-4.73,1,60.11,60.11,0,0,1-9.62-2.09c-3.2-.93-6.4-2-9.62-3.13-7.07-2.51-13.85-5.23-20.28-8l-.21-.09.08-.22,7.87-21.64.08-.21.21.08,20.17,8.07-.25.2c-1.39-9.84-2.52-17.81-3.3-23.35-.38-2.74-.67-4.88-.88-6.36l-.21-1.65c0-.38-.05-.57-.05-.57s0,.19.1.56.16.94.27,1.65c.22,1.47.55,3.6,1,6.34.82,5.53,2,13.5,3.47,23.33l0,.31-.3-.12-20.2-8,.3-.13c-2.45,6.76-5.07,14-7.83,21.65l-.13-.31c6.42,2.77,13.19,5.48,20.25,8,3.21,1.13,6.4,2.19,9.58,3.12a60.07,60.07,0,0,0,9.51,2.08,10.2,10.2,0,0,0,4.51-1,15,15,0,0,0,3.85-2.51,18.84,18.84,0,0,0,1.63-1.59,19.61,19.61,0,0,0,1.36-1.79,17.33,17.33,0,0,0,1.1-1.92,13,13,0,0,0,.74-2.06,11.81,11.81,0,0,0,.39-2.12,19,19,0,0,0,0-2.13c-.14-1.43-.24-2.85-.39-4.24-.27-2.78-.57-5.48-.87-8.09-.61-5.22-1.24-10.07-1.83-14.5-1.2-8.86-2.25-16-3-21-.36-2.45-.65-4.37-.84-5.69l-.21-1.48C616.56,205.85,616.55,205.67,616.55,205.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.53,198.63c0,.1-1.19.11-3,.67a13.32,13.32,0,0,0-9.31,10.37c-.36,1.85-.25,3-.34,3a2.36,2.36,0,0,1-.12-.83,10.61,10.61,0,0,1,.11-2.27A12.92,12.92,0,0,1,603.44,199a10.94,10.94,0,0,1,2.25-.36A2.64,2.64,0,0,1,606.53,198.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.73,222.49a26.8,26.8,0,0,0,2.13-4.65,27.71,27.71,0,0,0,.72-5.06,9.22,9.22,0,0,1-.24,5.2A9.12,9.12,0,0,1,511.73,222.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.55,249.62a3.08,3.08,0,0,1-.28-.58c-.17-.38-.41-.95-.71-1.68-.6-1.48-1.43-3.64-2.38-6.34s-2-6-3.06-9.66c-.52-1.85-1-3.8-1.55-5.83-.24-1-.49-2.07-.74-3.12s-.6-2.09-.9-3.16l-.06-.23.2-.09,2.91-1.28,3.37-1.48.12,0,.15.08a.28.28,0,0,1,.09.25c0,.11-.05.12-.07.14a.21.21,0,0,1-.14.08h-.28l-.21,0-.43,0-.85-.12-1.67-.24-3.22-.48-.28,0,.08-.28c2.17-6.81,4-12.68,5.38-16.92l1.6-4.88c.18-.53.33-1,.44-1.3a1.85,1.85,0,0,1,.19-.44,2.3,2.3,0,0,1-.1.46l-.37,1.33c-.36,1.2-.85,2.86-1.46,4.92-1.31,4.25-3.11,10.15-5.2,17l-.2-.32,3.21.47,1.67.23.84.11.42.05.21,0h.15s0,0,0,0a1.3,1.3,0,0,0,0,.23l.11.22-3.37,1.49-2.91,1.27.14-.32c.3,1.09.7,2.15.91,3.21l.73,3.12c.49,2,1,4,1.51,5.82,1,3.69,2,7,2.94,9.67s1.69,4.89,2.23,6.39c.26.71.46,1.28.62,1.72A3.48,3.48,0,0,1,559.55,249.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.09,191.31a2.67,2.67,0,0,1-.09.56c-.1.41-.22.94-.38,1.6-.33,1.38-.85,3.39-1.55,5.89-1.39,5-3.53,11.9-6.39,19.6l-.08.2-.21,0-4.92-.89.28-.36.19.42c1.17,2.58,2.3,5.08,3.36,7.45l.07.15-.11.12a186,186,0,0,1-13.17,13.36C568.36,241,567,242.17,566,243l-1.13.93a2.2,2.2,0,0,1-.41.3,2.17,2.17,0,0,1,.35-.37l1.08-1c1-.92,2.33-2.18,4-3.73,3.38-3.21,8-7.83,13-13.47l0,.27-3.37-7.43-.19-.42-.21-.46.49.09,4.92.9-.28.16c2.87-7.68,5.07-14.56,6.54-19.52.71-2.44,1.29-4.41,1.71-5.84.18-.65.34-1.17.45-1.58A2.92,2.92,0,0,1,593.09,191.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.65,383.05a1.65,1.65,0,0,1,0-.36l0-1.06c0-1,0-2.34,0-4.09,0-3.55,0-8.69,0-15,.11-12.7.46-30.24,1.06-49.6,1.24-38.42,2.18-67.29,2.27-70.14a2.45,2.45,0,0,1,0,.36v1.07c0,1,0,2.33,0,4.09,0,3.55-.12,8.68-.27,15-.29,12.7-.88,30.23-1.48,49.6s-1,36.9-1.21,49.59c-.09,6.33-.16,11.46-.2,15,0,1.75,0,3.12-.06,4.09,0,.44,0,.8,0,1.06A1.65,1.65,0,0,1,557.65,383.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "562.28 186.13 569.98 192.07 586.41 184.16 587.21 187.89 561.16 244.72 558.79 192.89 562.28 186.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "570.82 194.76 568.79 194.5 566.39 198.25 568.16 202.07 571.03 202.19 572.16 197.8 570.82 194.76",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.22,202s-8.05,21.16-8,21.24,1,21.67,1,21.67l11.63-25.59-1.74-17.21Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.68,208.62a2,2,0,0,1,.14.48l.3,1.41c.25,1.22.58,3,1,5.19.75,4.4,1.64,10.5,2.34,17.27s1.07,12.93,1.23,17.39c.08,2.23.12,4,.13,5.28v1.43a1.77,1.77,0,0,1,0,.5,1.68,1.68,0,0,1-.07-.49c0-.39,0-.86-.09-1.44-.07-1.32-.17-3.1-.29-5.27-.25-4.44-.68-10.58-1.38-17.35s-1.52-12.85-2.18-17.26c-.33-2.14-.59-3.91-.79-5.22-.08-.57-.15-1-.2-1.42A1.89,1.89,0,0,1,535.68,208.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.09,195.54a3.31,3.31,0,0,1-.63.49l-1.84,1.28L574,201.75l-.23.16-.11-.27c-1-2.66-2.55-5.61-3.85-8.92-.05-.11-.09-.22-.13-.32l.48,0a34.29,34.29,0,0,1-6,8.79l-.17.19-.16-.2a46.37,46.37,0,0,1-4.09-5.82c-.43-.74-.75-1.33-1-1.74a2.46,2.46,0,0,1-.28-.64,3.34,3.34,0,0,1,.4.58l1.06,1.67a58,58,0,0,0,4.21,5.67h-.33a35.64,35.64,0,0,0,5.81-8.72l.26-.54.22.56.12.32c1.29,3.27,2.81,6.24,3.8,8.95l-.34-.11,6.72-4.28,1.91-1.18A3.45,3.45,0,0,1,583.09,195.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.18,227.82l6.19,25.77c.34,1.42,1.62,2.43,3.67,3l35.12.12a4.15,4.15,0,0,0,2.56-4.33l-4.6-24.65a3.19,3.19,0,0,0-3.06-2.6l-37-.85A2.87,2.87,0,0,0,513.18,227.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.18,233s7.77-.31,9.08,0,18,11.14,18,11.14l-5,14.35L568.84,254a28.91,28.91,0,0,1-6.85-1.62c-2.44-1.13-5.3-2.35-5.3-2.35l-5.13.73-5.58.11s-1.91-1-.34-2.21,5.32-1.34,5.32-1.34l5.73-1.35s-6.58-.49-7.23-.6-5.11,1-5.71.58a1.73,1.73,0,0,1-.35-2.26c.5-.82,4.72-2.12,4.72-2.12l7.33-.68-7.25-.17-3.93-.23s-1.08-.78.32-1.94,7.07-2,7.07-2l5.84-.52-5.91-.62-3.9.71a1,1,0,0,1-.85-1.84A7.31,7.31,0,0,1,550.18,233Z",
    style: {
      fill: "#ffbf9d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.27,446.54l-.33,19s19.21,6.72,19.49,10.24l-36.89.67-.69-29.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5,464.16a1.5,1.5,0,0,0-1,1.73,1.45,1.45,0,0,0,1.72,1,1.6,1.6,0,0,0,1.06-1.85,1.51,1.51,0,0,0-1.9-.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.54,476.46l0-3,35.34.48s1.66.68,1.5,1.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.53,465.35c0,.18-.9.28-1.78.87s-1.33,1.36-1.5,1.29.08-1.11,1.16-1.81S355.57,465.18,355.53,465.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.43,466.88c0,.17-.73.49-1.33,1.26s-.76,1.59-.94,1.58-.31-1,.45-2S359.42,466.71,359.43,466.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.71,471.47c-.16,0-.43-.86,0-1.85s1.28-1.4,1.36-1.26-.43.69-.78,1.51S361.89,471.45,361.71,471.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.13,461c-.08.16-.91-.07-1.92,0s-1.81.42-1.91.27.66-.81,1.86-.9S355.21,460.86,355.13,461Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.27,445.37l-2,22.92,3.64,18.58a2.35,2.35,0,0,1-2,2.79h0a2.34,2.34,0,0,1-2-.74c-3.29-3.58-15.32-16.83-15.08-18.5.28-1.93.5-24.31.5-24.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.91,489.66l-17-20.79-.06,1a3.6,3.6,0,0,0,.69,2.35c1.35,1.8,5.18,6.71,14.28,16.72a2.36,2.36,0,0,0,2.1.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.09,461.77a1.42,1.42,0,0,1,.27,1.88,1.38,1.38,0,0,1-1.87.29,1.52,1.52,0,0,1-.27-2,1.43,1.43,0,0,1,2-.08",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.3,479.29a7.45,7.45,0,0,1,2.13-1.65,7.25,7.25,0,0,1,2.67-.34c0-.05-.25-.25-.78-.36a3.68,3.68,0,0,0-2.08.23,3.64,3.64,0,0,0-1.64,1.31C305.3,478.94,305.25,479.27,305.3,479.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.74,482.47a19.82,19.82,0,0,1,2.1-.85,19.86,19.86,0,0,1,2.26-.15,2.65,2.65,0,0,0-2.38-.35C307.35,481.43,306.62,482.4,306.74,482.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.51,475.16a21.86,21.86,0,0,1,3.15-1.54,24.15,24.15,0,0,1,3.45-.58,6.46,6.46,0,0,0-6.6,2.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.54,468.14c0,.14,1.35-.3,3-.26s2.94.53,3,.39a5.87,5.87,0,0,0-6-.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,461.4a7.51,7.51,0,0,1,6.12.61c0-.05-.19-.35-.7-.69a5.11,5.11,0,0,0-2.24-.78,5.17,5.17,0,0,0-2.36.32C303.21,461.1,302.92,461.35,303,461.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.12,459.76a2,2,0,0,0,.09-.86,6.17,6.17,0,0,0-.55-2.32,2.63,2.63,0,0,0-1.06-1.35.93.93,0,0,0-1.08.14,1.53,1.53,0,0,0-.43,1,3.32,3.32,0,0,0,2.71,3.26,3.85,3.85,0,0,0,3.92-1.77,1.37,1.37,0,0,0,.14-1.11.93.93,0,0,0-.94-.55,3.3,3.3,0,0,0-1.57.69,6.74,6.74,0,0,0-1.68,1.68,2.08,2.08,0,0,0-.4.77,11,11,0,0,1,2.28-2.16,3.09,3.09,0,0,1,1.38-.56.49.49,0,0,1,.51.29.91.91,0,0,1-.13.73,3.46,3.46,0,0,1-3.41,1.5,2.9,2.9,0,0,1-2.35-2.74,1.17,1.17,0,0,1,.27-.72.53.53,0,0,1,.6-.09,2.45,2.45,0,0,1,.92,1.13A8.85,8.85,0,0,1,306.12,459.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.2,287.8a181.24,181.24,0,0,1-.11,24.79c-.39,5.11-15.73,145.56-15.73,145.56H334.1l6.54-132.73-1.91.41S326,382.44,325,391.61c-.93,8.24-11.64,68.09-11.64,68.09l-21.26.24,6.79-79.16,7.9-76,3-22.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,311.88a4.71,4.71,0,0,0,1,.55,11.58,11.58,0,0,0,2.88,1,6.17,6.17,0,0,0,2.15,0,4.42,4.42,0,0,0,2.24-1.08,5.39,5.39,0,0,0,1.36-2.37c.27-.91.43-1.85.62-2.8.74-3.83,1.24-7.33,1.54-9.87.14-1.27.24-2.3.29-3a4.48,4.48,0,0,0,0-1.11,4.93,4.93,0,0,0-.22,1.09c-.12.81-.27,1.81-.45,3-.38,2.52-.94,6-1.68,9.82-.37,1.88-.63,3.81-1.81,4.93a4.79,4.79,0,0,1-4,1,13.2,13.2,0,0,1-2.86-.84A5.3,5.3,0,0,0,337,311.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,293.88s-.15-.13-.47-.15a2.16,2.16,0,0,0-1.31.42,2.34,2.34,0,0,0-1,1.8,2.2,2.2,0,0,0,1.49,2,2.18,2.18,0,0,0,2.44-.53,2.29,2.29,0,0,0,.44-2,2.13,2.13,0,0,0-.7-1.17c-.26-.2-.45-.23-.46-.2a2.56,2.56,0,0,1,.82,1.44,2,2,0,0,1-.44,1.63,1.88,1.88,0,0,1-3.13-1.17,2,2,0,0,1,.74-1.52A2.59,2.59,0,0,1,344,293.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.92 293.62 316.92 293.73 323.41 186.35 332.76 182.09 360.24 187.27 363.83 228.32 361.92 293.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.93,163.21a71.53,71.53,0,0,1-3.25-11.9,25,25,0,0,1,.83-12.2c.21-.59,2-4.54,2.63-4.48.45,0-.65,3.71-.42,4.09A21.11,21.11,0,0,1,333.25,151a55.55,55.55,0,0,1-2.32,12.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.08,185.16l-.75-36.82c-.46-10.32,5.16-19.19,15.49-19.37l1,0a18.47,18.47,0,0,1,17.69,17.72c.35,9,.62,18.84.37,23.62-.54,9.9-10.5,11-10.5,11s-.17,5.14-.17,8.05h0a12.38,12.38,0,0,1-18.83.47l-4.26-4.74Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.34,180.55a24,24,0,0,1-12.74-4.35s2.79,7.57,12.71,7.09Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.52,155a1.41,1.41,0,0,1-1.42,1.37,1.34,1.34,0,0,1-1.4-1.33,1.41,1.41,0,0,1,1.42-1.37A1.34,1.34,0,0,1,360.52,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.18,150.19c-.18.17-1.22-.66-2.74-.72s-2.67.65-2.83.46.12-.41.62-.74a3.77,3.77,0,0,1,2.27-.6,3.64,3.64,0,0,1,2.17.8C362.13,149.77,362.27,150.11,362.18,150.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.77,155a1.42,1.42,0,0,1-1.42,1.37,1.35,1.35,0,0,1-1.41-1.33,1.41,1.41,0,0,1,1.42-1.37A1.35,1.35,0,0,1,346.77,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.25,149.92c-.18.18-1.22-.66-2.74-.72s-2.67.66-2.83.47.11-.41.62-.75a3.91,3.91,0,0,1,2.27-.6,3.71,3.71,0,0,1,2.17.81C347.19,149.5,347.34,149.84,347.25,149.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.23,161.84a10.41,10.41,0,0,1,2.49-.34c.39,0,.76-.09.83-.35a1.91,1.91,0,0,0-.21-1.16c-.32-1-.67-2-1-3-1.43-4.28-2.44-7.79-2.27-7.85s1.47,3.37,2.89,7.65l1,3a2.27,2.27,0,0,1,.14,1.54,1,1,0,0,1-.66.54,2.81,2.81,0,0,1-.67.06A9.64,9.64,0,0,1,352.23,161.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,144.86c-.19.4-1.69.07-3.49.13s-3.28.41-3.48,0c-.09-.18.19-.55.81-.9a6.08,6.08,0,0,1,5.31-.12C347.78,144.31,348.08,144.67,348,144.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.53,145.17c-.26.39-1.54.22-3,.43s-2.68.65-3,.33c-.15-.15,0-.53.49-.93a4.78,4.78,0,0,1,2.36-.94,4.71,4.71,0,0,1,2.51.32C362.42,144.65,362.64,145,362.53,145.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.84,154.87c-.17-.08-6.72-2.3-6.78,4.48s6.75,5.45,6.77,5.25S330.84,154.87,330.84,154.87Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.78,162s-.12.08-.32.17a1.24,1.24,0,0,1-.88,0,2.91,2.91,0,0,1-1.33-2.64,3.94,3.94,0,0,1,.34-1.68,1.38,1.38,0,0,1,.9-.9.62.62,0,0,1,.7.33c.08.19,0,.32.08.33s.14-.11.09-.39a.8.8,0,0,0-.26-.43.88.88,0,0,0-.65-.17,1.65,1.65,0,0,0-1.25,1,4,4,0,0,0-.42,1.88,3,3,0,0,0,1.69,2.94,1.28,1.28,0,0,0,1.08-.16C328.76,162.18,328.8,162,328.78,162Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.09,134.67c1.1-.61-2.19-4.16-4.89-5.39-4.07-1.85-10.3-3-14.05-1.93-4.53,1.28-8.29,3.53-10.56,7.65a26.57,26.57,0,0,0-3,13.61,8.12,8.12,0,0,0,1,4.14c.95,1.5,2.76,2.45,2.68,4.52a2.85,2.85,0,0,0,.71,2.07c1.23,1.32,2.75.08,3.45-1.17,1.49-2.65,1.66-5.82,1.79-8.86a19.65,19.65,0,0,0-.42-6.45c-.33-1.13-.87-2.2-1.13-3.35a4,4,0,0,1,.48-3.38,5.53,5.53,0,0,1,.55-.56,7.07,7.07,0,0,1,7-1.33c3.82,1.36,10.34,3.38,12,2.08a10.45,10.45,0,0,0,3-3.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.45,162.78c.23,0,.24,1.55,1.58,2.65s3,.92,3,1.13-.36.31-1.06.33a3.85,3.85,0,0,1-2.51-.86,3.4,3.4,0,0,1-1.23-2.22C347.17,163.16,347.34,162.78,347.45,162.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.29,217.26s.66,1.07,1.87,2.78,2.91,4.1,4.86,6.79l.15.21-.24.07-1.63.47.13-.14c0,.18-.07.37-.11.56-.11.53-.21,1-.31,1.53l-.33.05.34-.08-.33.09c-1.85-3-3.43-5.64-4.51-7.61-.14-.25-.26-.48-.37-.7l-.33-.63a2.74,2.74,0,0,1-.32-1.1,5.63,5.63,0,0,1,0-.72.92.92,0,0,1,0-.24s0,.34.09.94a2.66,2.66,0,0,0,.36,1l.35.62c.12.22.25.46.4.69,1.12,1.92,2.74,4.57,4.59,7.54l-.33.09.34-.08-.33,0c.09-.48.19-1,.3-1.53,0-.19.07-.38.11-.56l0-.11.1,0,1.63-.46-.09.27C367.84,221.64,365.08,217.38,365.29,217.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.73,214.31s.31-.56,1.23-.78a2.36,2.36,0,0,1,1.62.17,2.2,2.2,0,0,1,1,1.73,3.23,3.23,0,0,1-.5,1.91,7.55,7.55,0,0,1-1,1.25,4,4,0,0,1-1.1.93,11.54,11.54,0,0,1,.91-1.1,8.44,8.44,0,0,0,.87-1.25,2.91,2.91,0,0,0,.43-1.71,1.92,1.92,0,0,0-.8-1.47,2.14,2.14,0,0,0-1.4-.21A3.86,3.86,0,0,0,365.73,214.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.9,287.41l.76-105.32,4.11,3.53,12.78,2.59a20.53,20.53,0,0,1,9.9,5.84c6.49,7.67,5.46,7.77,9.43,13.78,3.25,4.94,14.27,19.91,17,30.31,0,0,1.21,12.68-7.82,15.83h0C394,256.75,385,250,380.9,244.3l-7-11.19,1.55,40,7.48,90.5-26,.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M376.76,197.16a2.19,2.19,0,0,1,0,.45c0,.33,0,.76,0,1.29,0,1.13-.05,2.76-.13,4.77-.17,4-.61,9.56-1.14,15.67S374.58,231,374.43,235c-.08,2-.12,3.64-.13,4.76,0,.53,0,1,0,1.3a2.71,2.71,0,0,1,0,.45,2,2,0,0,1,0-.45c0-.34,0-.77,0-1.3,0-1.12,0-2.75,0-4.76.08-4,.45-9.58,1-15.69s1-11.64,1.23-15.66c.12-2,.21-3.63.25-4.75q0-.79.06-1.29A2.23,2.23,0,0,1,376.76,197.16Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.9,239.8a3.53,3.53,0,0,1,.18-.58c.15-.4.34-.95.58-1.64.49-1.42,1.16-3.49,1.94-6.07s1.69-5.65,2.84-9c.58-1.69,1.22-3.45,1.93-5.25.37-.9.73-1.82,1.13-2.73s.84-1.84,1.15-2.8a5.06,5.06,0,0,0,.23-2.89,6.6,6.6,0,0,0-1.52-2.42,5.11,5.11,0,0,1-1.38-2.55,3.47,3.47,0,0,1,.17-1.44,7.24,7.24,0,0,1,.61-1.25c.47-.76,1-1.45,1.41-2.17a3.72,3.72,0,0,0,.55-2.25,5.79,5.79,0,0,0-.85-2.05l-1.07-1.82c-1.35-2.3-2.44-4.18-3.22-5.51l-.86-1.5a4.48,4.48,0,0,1-.28-.54,3.61,3.61,0,0,1,.34.5c.23.36.54.85.92,1.47l3.31,5.45,1.1,1.81a6.13,6.13,0,0,1,.91,2.15,4,4,0,0,1-.57,2.44c-.42.75-.95,1.45-1.41,2.2a6.12,6.12,0,0,0-.57,1.18,3.27,3.27,0,0,0-.15,1.28,4.71,4.71,0,0,0,1.31,2.38,6.88,6.88,0,0,1,1.6,2.55,5.44,5.44,0,0,1-.24,3.09c-.32,1-.77,1.91-1.16,2.83s-.77,1.82-1.14,2.72c-.7,1.8-1.36,3.55-1.94,5.23-1.16,3.36-2.09,6.42-2.91,9s-1.52,4.63-2,6c-.26.71-.49,1.25-.64,1.62A4.36,4.36,0,0,1,354.9,239.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.47,174l-7,13.2s-11-6.94-11-7.45S303,168.91,303,168.91Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,144.79l-1.16,1.12a.4.4,0,0,0,0,.62l35.06,25.86,0,0,3.74,2.3a.58.58,0,0,0,.74-.89l-2.82-3.11-.06-.05-35-25.9A.42.42,0,0,0,312.75,144.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,144.79a.31.31,0,0,1,.23-.12.4.4,0,0,1,.32.07l.36.26,2.37,1.71,8.69,6.35,12.86,9.45,7.58,5.6,2,1.46,1,.75.25.19a3,3,0,0,1,.25.24l.42.47,1.72,1.89.43.47a.86.86,0,0,1,.3.71.81.81,0,0,1-.48.64.85.85,0,0,1-.42,0,1.14,1.14,0,0,1-.35-.16l-2.2-1.36-1.09-.67-.27-.16-.15-.1-.13-.09-.51-.38-4-3-7.58-5.6L321.52,154l-8.63-6.43-1.35-1a.46.46,0,0,1,0-.67l.41-.39.56-.51.2-.17a1.29,1.29,0,0,1-.17.2q-.21.19-.54.54l-.4.39a.36.36,0,0,0,0,.53l1.35,1,8.7,6.34,12.87,9.44,7.59,5.59,4,2.95.51.38.12.09.13.08.27.17,1.09.67,2.2,1.35a.45.45,0,0,0,.45.1.45.45,0,0,0,.26-.35c0-.16-.05-.25-.22-.43l-.43-.47c-.57-.63-1.15-1.26-1.71-1.89l-.43-.47c-.07-.07-.15-.17-.19-.2l-.25-.19-1-.74-2-1.47-7.57-5.61-12.81-9.52L316,146.82l-2.33-1.77c-.27-.2-.46-.39-.64-.35S312.76,144.81,312.75,144.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,151.72a1.15,1.15,0,0,0-.18-2.11c-2.8-.93-8.81-2.81-10.38-2.2-2.07.79-10.35,2.82-10.92,4.32s-.13,8.32-.13,8.32l.75,9.88,9.29,5.53a7.22,7.22,0,0,0,2.26-5.38c-.08-4.61-.42-4.59-.42-4.59l2.44-3.45s-2.45,3.7,0,4.45c0,0,3-3,3.34-4.17a5.69,5.69,0,0,0-.23-2.8s1.46-1.46.13-2.79c0,0,1.63-.69.47-2.39a6.54,6.54,0,0,0-3.17-2.31l-1.95-1S321.94,152.79,324,151.72Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.89,161.06a5.21,5.21,0,0,1,1-1.05,6.75,6.75,0,0,1,3.18-1.66,5.64,5.64,0,0,1,3.55.54,2.91,2.91,0,0,1,1.17.92c0,.05-.47-.33-1.28-.69a5.93,5.93,0,0,0-3.38-.42,7.45,7.45,0,0,0-3.08,1.5A6.92,6.92,0,0,1,310.89,161.06Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.57,157.48s0-.18.17-.47a5.12,5.12,0,0,1,.77-1.12,6,6,0,0,1,8.23-.71,4.76,4.76,0,0,1,1,1c.19.26.27.42.25.43a15.64,15.64,0,0,0-1.36-1.21,6,6,0,0,0-7.89.68A14,14,0,0,0,309.57,157.48Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.56,154c0-.05.6-.38,1.48-1.09.45-.35,1-.78,1.58-1.24a7.11,7.11,0,0,1,2.21-1.16,4.73,4.73,0,0,1,2.51,0,7.62,7.62,0,0,1,1.87.79,6.21,6.21,0,0,1,1.49,1.11c0,.05-.61-.36-1.61-.88a7.6,7.6,0,0,0-1.83-.7,4.64,4.64,0,0,0-2.34,0,7.37,7.37,0,0,0-2.11,1.08l-1.62,1.18A5.08,5.08,0,0,1,306.56,154Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.55,176.41l.81,13,8.52,18.87a1.67,1.67,0,0,1-1.52,2.35H343.2a1.66,1.66,0,0,1-1.53-2.31l8-19.17V176.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.55,176.41l-.47,0-1.34,0-5.06.05.09-.09c0,3.23,0,7.58.05,12.74v0c-1.64,3.94-3.5,8.43-5.53,13.3l-1.55,3.73c-.27.63-.53,1.27-.8,1.91a1.8,1.8,0,0,0-.21.93,1.43,1.43,0,0,0,.35.86,1.45,1.45,0,0,0,.8.48,5.73,5.73,0,0,0,1,0h20.23a1.7,1.7,0,0,0,1.12-.29,1.53,1.53,0,0,0,.59-1,1.76,1.76,0,0,0-.23-1.12L365.1,207l-1-2.23-6.84-15.26v0c-.22-4-.41-7.28-.53-9.53-.06-1.1-.1-2-.13-2.57,0-.28,0-.51,0-.67a.73.73,0,0,1,0-.24s0,.07,0,.21,0,.38.05.65c.05.6.11,1.45.19,2.55.16,2.26.39,5.51.67,9.58v0c1.9,4.19,4.26,9.37,6.92,15.22.33.74.67,1.48,1,2.23l.52,1.14a2.1,2.1,0,0,1,.25,1.32,1.82,1.82,0,0,1-.72,1.17,2.11,2.11,0,0,1-.64.31,2.7,2.7,0,0,1-.68.05H343.9a6.09,6.09,0,0,1-1.11-.05,1.83,1.83,0,0,1-1.42-1.66,2.19,2.19,0,0,1,.24-1.09c.27-.64.53-1.28.8-1.91l1.56-3.73c2-4.87,3.93-9.35,5.58-13.28v.06c0-5.16,0-9.51,0-12.74v-.09h.09l5.11.05,1.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.31,
    y: 175.72,
    width: 9.51,
    height: 2.36,
    rx: 1.14,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.45,178.09a.94.94,0,0,1-.83-.26,1.21,1.21,0,0,1-.41-1,1.25,1.25,0,0,1,.73-1.17,1.76,1.76,0,0,1,.81-.12h.84l1.85,0h4.24a1.27,1.27,0,0,1,1.09.58,1.25,1.25,0,0,1,.22.58,1.52,1.52,0,0,1-.05.6,1.29,1.29,0,0,1-.78.86,1.6,1.6,0,0,1-.56.09h-.5l-3.46,0-2.33-.05a4.19,4.19,0,0,1-.86-.07,3.45,3.45,0,0,1,.86-.07l2.33-.06,3.46,0a2.75,2.75,0,0,0,.93-.07,1,1,0,0,0,.58-.63,1.11,1.11,0,0,0-.13-.89,1,1,0,0,0-.8-.43h-4.24l-1.85,0h-.84a1.58,1.58,0,0,0-.71.08,1,1,0,0,0-.63.94,1.08,1.08,0,0,0,.31.85A1.49,1.49,0,0,0,349.45,178.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,197.86c.07.14,2.59,6.3,3.94,9.59a1.47,1.47,0,0,1-1.36,2H344.77a1.47,1.47,0,0,1-1.36-2l3.81-9.6Z",
    style: {
      fill: "#5EFF64"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M401.79,235.52a2.2,2.2,0,0,1-.29-.32l-.79-.93c-.68-.81-1.66-2-2.9-3.42-2.49-2.86-6-6.72-10.23-10.7-1.84-1.74-3.65-3.36-5.32-4.81h.22a44.2,44.2,0,0,0-6.22,7.64c-.66,1-1.15,1.86-1.48,2.43a6.93,6.93,0,0,1-.53.88,2.05,2.05,0,0,1,.1-.25c.07-.15.18-.39.33-.68.3-.59.76-1.45,1.4-2.49a41.5,41.5,0,0,1,6.17-7.77l.11-.11.12.11c1.69,1.44,3.5,3.06,5.34,4.8A132.91,132.91,0,0,1,398,230.69c1.22,1.45,2.17,2.65,2.82,3.49l.74,1A1.88,1.88,0,0,1,401.79,235.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.83,204a29.63,29.63,0,0,0-3.22-3.48L361,191.58,354.46,189l-6.35,2.86s0,3,2.36,2.51a26.77,26.77,0,0,0,3.31-.89l3.22,1.35,2.53,4.6-6.18.39-8,4.17a3.94,3.94,0,0,0,3,2.14,12.62,12.62,0,0,0,4.4-1.18l4.19-.52-9.51,5.68,2.32,2.06-1.67,1.16,1.19.77a3.79,3.79,0,0,0,3,.51l8.55-2.09s5.16,8.92,9,10.72,4.62,2.7,4.62,2.7l6.45-9.29Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.93,209.7s-.14-.24-.44-.61a4,4,0,0,0-1.6-1.15,5.21,5.21,0,0,0-2.9-.3,12.33,12.33,0,0,0-3.45,1.19c-2.36,1.14-4.41,2.36-5.9,3.24l-1.77,1a2.89,2.89,0,0,1-.67.34,3.41,3.41,0,0,1,.6-.46c.4-.27,1-.66,1.71-1.13a55.3,55.3,0,0,1,5.88-3.34,12.08,12.08,0,0,1,3.56-1.2,5.38,5.38,0,0,1,3,.4,4,4,0,0,1,1.62,1.3A1.6,1.6,0,0,1,364.93,209.7Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.24,203.76a10.52,10.52,0,0,0-8.54.78,3.33,3.33,0,0,1,1.08-.76,8.3,8.3,0,0,1,6.26-.57A3.58,3.58,0,0,1,365.24,203.76Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.74,201.18a8.34,8.34,0,0,0-2.46-1.44,8.25,8.25,0,0,0-2.85-.19s.29-.2.83-.3a4.7,4.7,0,0,1,4,1.22C364.61,200.85,364.77,201.15,364.74,201.18Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.26,187.15,273.53,212l.29,11.74c1.29,2.72,9.74,3.84,16.55,1l25.74-14.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.77,186.35s8-1.37,11.67-1.83l6.72-.84,4.09-3.61c0,.8,4.47,75.88,4.47,75.88l-32.34,5.95L306,209.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.72 254.93 329.18 363.61 296.18 362.92 303.38 258.81 335.72 254.93",
    style: {
      fill: "#e0e0e0"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M335.13,238.14a3.51,3.51,0,0,1-.26-.55l-.65-1.58c-.55-1.38-1.32-3.39-2.25-5.88-1.87-5-4.37-11.89-7.65-19.3a12.74,12.74,0,0,1-1-2.88,4.17,4.17,0,0,1,.43-2.94,21.45,21.45,0,0,1,1.72-2.25,3.17,3.17,0,0,0,.79-2.37,5.3,5.3,0,0,0-1-2.27,19.7,19.7,0,0,1-1.29-2.07,3.71,3.71,0,0,1-.39-2.27c.14-.73.32-1.4.49-2.05a26,26,0,0,1,1.15-3.41l1-2.51.65-1.58a4.36,4.36,0,0,1,.25-.55,3.64,3.64,0,0,1-.18.57c-.15.4-.34.94-.59,1.61s-.58,1.56-.95,2.54a26.29,26.29,0,0,0-1.09,3.4c-.17.64-.34,1.32-.46,2a3.35,3.35,0,0,0,.38,2.1,21.14,21.14,0,0,0,1.28,2,5.68,5.68,0,0,1,1.05,2.4,3.51,3.51,0,0,1-.85,2.62,25.35,25.35,0,0,0-1.69,2.21,3.83,3.83,0,0,0-.38,2.71,12.3,12.3,0,0,0,1,2.79c3.3,7.43,5.76,14.36,7.57,19.36.9,2.47,1.63,4.49,2.14,5.92.25.67.45,1.21.59,1.61A4.24,4.24,0,0,1,335.13,238.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.36,204.34a90,90,0,0,1,5.23-8.6l19.53-26L312,181.86l-15.63,26.55-17.76,15.33-4.53.32C269.07,219.89,267.81,213.28,272.36,204.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290.65,214.27a1.55,1.55,0,0,1,.18-.36l.58-1,2.19-3.58c1.87-3,4.49-7.15,7.45-11.67s5.72-8.58,7.78-11.47c1-1.44,1.87-2.61,2.48-3.39l.69-.91a2.83,2.83,0,0,1,.27-.3,1.47,1.47,0,0,1-.21.35l-.64.94L309,186.34c-2,2.93-4.73,7-7.69,11.52s-5.58,8.61-7.54,11.62L291.53,213l-.64.95A3,3,0,0,1,290.65,214.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.19,210.2c-.61-1.57-1.13-3.39-.39-4.91s2.56-2.45,2.82-4a4.6,4.6,0,0,0-1-3.25,12.26,12.26,0,0,1-1.75-3c-.34-1.11,1-5.94,1.38-6.71L327,184a38.6,38.6,0,0,0-3.33,6.37,12.85,12.85,0,0,0-.73,7.06,15.93,15.93,0,0,1,.82,4.05c-.08,1.79-1.22,3.33-1.79,5-1.27,3.77.37,7.84,2.12,11.41a166,166,0,0,0,9.64,16.58C330.35,224.59,327.11,217.74,324.19,210.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M305.22,197.86a3.35,3.35,0,0,1,.07.57c0,.44.07,1,.11,1.66.07,1.52.17,3.59.29,6.12.22,5.16.45,12.29.6,20.17s.17,15,.09,20.19c-.06,2.59-.11,4.68-.18,6.12,0,.67-.07,1.22-.09,1.66a2.45,2.45,0,0,1-.07.58,3.29,3.29,0,0,1,0-.58v-1.67c0-1.51,0-3.58,0-6.11,0-5.16-.08-12.3-.24-20.18s-.33-14.94-.44-20.17c-.06-2.53-.1-4.6-.13-6.12,0-.67,0-1.22,0-1.66A2.17,2.17,0,0,1,305.22,197.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.31,441.83l-1.45,20.33S202,470,202,473.82l-39.43-1,1-31.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,460.09a1.64,1.64,0,0,0-1.19,1.82,1.57,1.57,0,0,0,1.79,1.2,1.73,1.73,0,0,0,1.25-1.93,1.62,1.62,0,0,0-2-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.61,472.84l.08-2.53L200.94,472a3,3,0,0,1,1.29,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.21,462.3c0,.2-1,.25-2,.84s-1.51,1.39-1.69,1.31.15-1.2,1.35-1.89S182.26,462.12,182.21,462.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.32,464.18c0,.19-.81.49-1.5,1.29s-.91,1.66-1.1,1.64-.28-1.12.59-2.09S186.33,464,186.32,464.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.52,469.26c-.18,0-.42-.95.12-2s1.46-1.44,1.54-1.28-.51.72-.94,1.58S188.71,469.25,188.52,469.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,457.6c-.09.17-1-.13-2.07-.09s-2,.35-2.07.18.75-.84,2.05-.86S182.13,457.45,182,457.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.89,453.24a3.78,3.78,0,0,1-2-.08,9.1,9.1,0,0,1-2.06-.72,8.81,8.81,0,0,1-1.13-.65,2.26,2.26,0,0,1-.58-.49.84.84,0,0,1,0-1,1.07,1.07,0,0,1,.86-.42,2.66,2.66,0,0,1,.75.13,7.14,7.14,0,0,1,3,1.74c.89.89,1.18,1.63,1.11,1.66s-.52-.56-1.43-1.3a7.86,7.86,0,0,0-1.74-1.06,7.26,7.26,0,0,0-1.14-.4c-.41-.12-.77-.14-.89,0s-.05.1,0,.23a2.08,2.08,0,0,0,.43.36,11.55,11.55,0,0,0,1,.64,11,11,0,0,0,1.9.8A12.39,12.39,0,0,1,182.89,453.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.07,394.85l11.21,17s20.74-5.95,23.11-3l-31.91,23.19-18.54-25.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.57,417.47a1.61,1.61,0,0,0,.16,2.16,1.56,1.56,0,0,0,2.15-.13,1.72,1.72,0,0,0-.18-2.29,1.61,1.61,0,0,0-2.22.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.48,432.06,225,430l31.42-21.88a3,3,0,0,1,2.25.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.64,411.78c.11.16-.63.79-1,1.86s-.36,2-.55,2.06-.6-1-.08-2.32S235.57,411.61,235.64,411.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.05,410.76c.15.13-.35.89-.41,1.94s.28,1.88.12,2-.9-.72-.8-2S239.94,410.62,240.05,410.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.88,413.47c-.12.13-.9-.5-1.11-1.66s.28-2,.44-1.95,0,.88.22,1.83S245,413.34,244.88,413.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.64,408.15c0,.19-.85.49-1.7,1.19s-1.35,1.48-1.53,1.4.09-1.12,1.11-1.93S232.63,408,232.64,408.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.68,404.16c0,.07-.51.61-1.64,1.15A9.11,9.11,0,0,1,227,406a8.58,8.58,0,0,1-1.29.16,2.52,2.52,0,0,1-.76,0,.85.85,0,0,1-.67-.79,1.08,1.08,0,0,1,.44-.86,2.71,2.71,0,0,1,.67-.35,6.8,6.8,0,0,1,1.25-.37,7,7,0,0,1,2.2-.08,3.34,3.34,0,0,1,1.9.64c0,.11-.76-.13-1.93-.16a7.57,7.57,0,0,0-2,.21,7.26,7.26,0,0,0-1.14.38c-.41.15-.7.36-.68.57s0,.11.16.16a2,2,0,0,0,.56,0,9.18,9.18,0,0,0,1.21-.12,11,11,0,0,0,2-.51A15.62,15.62,0,0,1,230.68,404.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2,331.81c.77,0-2,19.27,25.08,22.42s37.4,6.92,42.66,13.27-7.35,87.22-7.35,87.22l-22-1.33s1.59-42.9,2-48.06,3.75-18.81,3.75-18.81h0l-57.26,1.57c-.33,0-.67,0-1,0-12.79-.19-23-16.43-22.18-29.19l1-18.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.37,345.73s26.42-7.94,40.58-9.47,22.42.65,24.88,3.22c5.72,6,43.71,65.31,43.71,65.31l-19.49,13.88s-33.25-45.29-42.48-57.25l-3.17-3.64-44.3-5.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.79,350.46s.06,0,.19.06l.58.12,2.24.44,8.22,1.54,27.16,4.94,2.18.4-.13-.11a74.17,74.17,0,0,0,14.68,21.51,62.14,62.14,0,0,0,5.88,5.2l1.71,1.26.45.32.16.1s0-.05-.14-.13l-.43-.35-1.67-1.31a69.23,69.23,0,0,1-5.78-5.26,75.5,75.5,0,0,1-7.42-9,73.68,73.68,0,0,1-7.11-12.48l0-.09-.09,0-2.19-.39-27.17-4.85-8.25-1.42-2.25-.37-.58-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,337.87H144.1l5.8-20.18L92.08,307.54s-1.72,22.31-4.79,36-.24,39.25,13.27,41.2h39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.73,252l-4.17,3s-15.66,3-20.41,5.67c-13,7.42-12,54.62-12,54.62l-1.93,17.51L100,331l34.4-.47L139.48,317l9.42-18.33L146.19,297l6.87-21-4.72-4.88-1.78-7.26L130.73,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.83 265.28 130.31 252.47 130.55 251.1 128.52 252.3 138.57 300.88 146.83 265.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.82,329.13l.07-.21.22-.59c.19-.53.48-1.3.85-2.29s.83-2.2,1.35-3.61c.27-.7.55-1.45.85-2.25l.47-1.23c.15-.42.3-.86.46-1.3.63-1.79,1.33-3.74,2.08-5.83l1.15-3.25c.4-1.12.84-2.26,1.19-3.46a8,8,0,0,0,.38-1.83,4,4,0,0,0-.34-1.86c-.24-.6-.55-1.19-.83-1.79s-.57-1.22-.86-1.84c-1.14-2.47-2.18-5.1-3.18-7.8-1.65-4.5-3.1-8.86-4.67-12.83l0-.05,0,0c1.28-1.26,2.45-2.54,3.56-3.78l0,.14a11.71,11.71,0,0,0-4.75-.53h-.07l0-.07c-1.18-5.35-2.06-9.8-2.59-12.92-.27-1.56-.44-2.78-.53-3.62s-.11-1.29-.11-1.29,0,.11,0,.33.06.53.11,1c.11.84.3,2.06.58,3.62.55,3.11,1.45,7.55,2.65,12.9l-.08-.06a11.85,11.85,0,0,1,4.82.51l.12,0-.08.1c-1.11,1.25-2.28,2.53-3.57,3.79l0-.09c1.59,4,3,8.33,4.69,12.82,1,2.71,2,5.33,3.17,7.8.29.61.57,1.23.85,1.83s.59,1.19.84,1.81a4.27,4.27,0,0,1,.35,1.93,8.17,8.17,0,0,1-.39,1.87c-.36,1.21-.8,2.35-1.2,3.46l-1.17,3.25c-.75,2.09-1.45,4-2.1,5.82-.16.45-.31.88-.47,1.3s-.31.83-.47,1.23c-.3.8-.59,1.55-.86,2.25l-1.38,3.6c-.39,1-.68,1.75-.89,2.27-.1.26-.18.45-.23.59A1.6,1.6,0,0,1,128.82,329.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.21,280.33s0,0,0,.09l-.07.24q-.1.34-.27,1c-.25.84-.6,2-1,3.52L146.28,297l0-.11,2.22,1.41.44.27.07.05,0,.08L142.64,311c-.81,1.55-1.46,2.81-1.92,3.7l-.53,1a2.83,2.83,0,0,1-.14.26L140,316a.55.55,0,0,1,0-.1l.12-.26.5-1,1.86-3.72,6.24-12.31,0,.12-.43-.27L146.14,297l-.06,0,0-.06c1.43-4.69,2.7-8.84,3.61-11.84.46-1.47.83-2.67,1.08-3.5.13-.4.23-.72.31-1l.08-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.34,271.12a.66.66,0,0,1,0,.09l0,.24c0,.23.09.54.15.94.13.84.31,2,.53,3.5V276H149l-2.39.22.05-.12,1.9,2.55,0,0,0,.05-2.75,6.84-4.73,11.65-1.46,3.52-.4.95-.11.25c0,.06,0,.08,0,.08l0-.09.09-.25c.09-.23.22-.56.37-1,.34-.85.82-2.05,1.4-3.54,1.2-3,2.86-7.12,4.68-11.67,1-2.44,1.94-4.77,2.77-6.84v.09l-1.88-2.56-.08-.11h.13l2.4-.2-.06.07c-.2-1.47-.36-2.66-.47-3.5,0-.4-.08-.72-.11-.95l0-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.63,275.61s-.09-.07-.23-.21l-.59-.65a23.62,23.62,0,0,1-1.87-2.5l.15,0a18.32,18.32,0,0,1-1.82,3.84c-.29.47-.61.93-.93,1.35l-.08.11-.07-.12-2.42-4.29-.69-1.27a2.79,2.79,0,0,1-.23-.47,4.05,4.05,0,0,1,.29.44l.74,1.24c.63,1.1,1.49,2.58,2.47,4.26h-.15c.31-.42.62-.87.91-1.34a18.78,18.78,0,0,0,1.82-3.79L139,272l.09.14a26.44,26.44,0,0,0,1.81,2.53c.22.27.4.5.55.67A2,2,0,0,1,141.63,275.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,300a1.28,1.28,0,0,1,0-.26c0-.18.05-.42.08-.72.07-.62.18-1.53.32-2.64.29-2.23.72-5.31,1.24-8.7s1-6.46,1.45-8.67c.2-1.11.37-2,.49-2.62l.15-.71a.81.81,0,0,1,.06-.24,1,1,0,0,1,0,.25c0,.18-.07.42-.11.71-.11.65-.26,1.54-.44,2.63-.37,2.22-.87,5.29-1.39,8.68s-1,6.46-1.3,8.69c-.16,1.09-.29,2-.38,2.63,0,.3-.08.54-.11.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.61,257.59l.11.8,2.33,16.17,3.78-.4L127,276.33l9.91,27.18-.58,5.33s2.1-5.6,1.71-6.43c-.94-2-9.94-25.28-9.94-25.28l3.57-3.78-4.79-.52Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "147.78 294.57 150.58 283.02 146.13 296.94 148.9 298.68 143.18 309.61 144.32 310.74 149.84 298.58 147.78 294.57"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M146.78,297.22l2.62-5.16a.83.83,0,0,1,1.21-.31h0a.84.84,0,0,1,.27,1.06l-2.7,5.33Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.05,351.23a11.59,11.59,0,0,1-1.66-.34l-4.47-1.13c-3.77-1-9-2.36-14.74-3.63a126.2,126.2,0,0,0-15-2.41c-1.94-.18-3.5-.3-4.59-.35a10.11,10.11,0,0,1-1.68-.16,10.14,10.14,0,0,1,1.69,0c1.09,0,2.66.06,4.61.19a106,106,0,0,1,15,2.27c5.81,1.28,11,2.74,14.73,3.79l4.42,1.28A9.13,9.13,0,0,1,152.05,351.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,260.06s-6.06,9.82-6.7,11.07-.21,7.25-.21,7.25l-3.32,4.48,6.29,9.4,6-10s3.11-2.07,4.07-3.65,6.27-11.75,6.27-11.75l.06-5.11s.53-2-1.07-2.23a1.79,1.79,0,0,0-2,1.3s2.09-2.75.68-3.94-2.28-.11-2.76.54-2.46,2.54-2.46,2.54,2.16-3.2,1.81-3.88a1.34,1.34,0,0,0-1.9-.63,3.94,3.94,0,0,0-2.46,2c-.72,1.26-1.59,2.63-1.59,2.63Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,277.31l.07-.18.2-.48a6.16,6.16,0,0,0,.39-1.88c0-.21,0-.42,0-.64s-.05-.45-.07-.69a7.12,7.12,0,0,0-.44-1.46,6.67,6.67,0,0,0-.84-1.48,5.12,5.12,0,0,0-1.29-1.25l-.09-.06.07-.09.2-.23a11.87,11.87,0,0,0,1.77-3.18,10.23,10.23,0,0,0,.51-1.5,5.06,5.06,0,0,0,.11-1.37,4,4,0,0,0-.57-1.89c-.25-.4-.46-.57-.44-.59l.15.13a2.11,2.11,0,0,1,.35.42,3.91,3.91,0,0,1,.65,1.92,5.33,5.33,0,0,1-.1,1.41,9.84,9.84,0,0,1-.5,1.54A11.65,11.65,0,0,1,180.3,269l-.21.24,0-.14a5.07,5.07,0,0,1,1.34,1.31,6.91,6.91,0,0,1,.85,1.51,7.59,7.59,0,0,1,.43,1.5c0,.25.06.48.07.71s0,.45,0,.65a6,6,0,0,1-.45,1.91l-.24.47C182,277.26,182,277.31,182,277.31Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.55,279.49l-11.18,16.26L153.06,276l-11.13,32.44s10.82,10.89,18.14,12.78,9.24-1.88,10.76-6.14c.91-2.57,14.14-25.73,14.14-25.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,295.14s0,.07,0,.17-.12.29-.2.48-.2.45-.31.74-.26.63-.38,1c-.27.75-.55,1.65-.82,2.67a31,31,0,0,0-.64,3.34,29.87,29.87,0,0,0-.23,3.4,25.64,25.64,0,0,0,.11,2.78c0,.4.08.75.11,1.07s.07.58.11.8l.07.51c0,.11,0,.17,0,.17a.91.91,0,0,1,0-.17l-.1-.5a8.06,8.06,0,0,1-.14-.8c-.05-.31-.11-.67-.14-1.06a25.09,25.09,0,0,1-.16-2.8,30.23,30.23,0,0,1,.22-3.42,29.18,29.18,0,0,1,.66-3.37,27.12,27.12,0,0,1,.86-2.66c.14-.38.29-.71.41-1s.24-.54.34-.73l.23-.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.66 268.07 178.13 268.6 177.41 269.51 177.78 272.34 178.73 273.07 183.09 272.28 182.66 268.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.17,268.56a14.94,14.94,0,0,0,.22,2.19,13.34,13.34,0,0,0,.4,2.16,26.5,26.5,0,0,0-.62-4.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.48,272.93a14,14,0,0,0-.26-2.21,14.17,14.17,0,0,0-.43-2.18,12.71,12.71,0,0,0,.26,2.21A14.17,14.17,0,0,0,179.48,272.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,275.18c0,.26-2.9,4.39-2.9,4.39h-2.64l-1-.74-.45-2.56,3.16-4.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,276.27a3.91,3.91,0,0,0,.62.47c.39.28.92.67,1.49,1.14,1.14.92,2,1.75,2,1.71a3.32,3.32,0,0,0-.52-.58,18,18,0,0,0-1.4-1.27,15.52,15.52,0,0,0-1.53-1.11A2.94,2.94,0,0,0,180,276.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.31,275.87a25.24,25.24,0,0,1,2.19,1.48,18.35,18.35,0,0,1,1.88,1.84,2.21,2.21,0,0,0-.43-.65,8.84,8.84,0,0,0-1.34-1.33,9.36,9.36,0,0,0-1.58-1A2.54,2.54,0,0,0,180.31,275.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.3,
    y: 274.8,
    width: 4.86,
    height: 6.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.23,280.68a32.58,32.58,0,0,0,4.84,0,32.58,32.58,0,0,0-4.84,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.2,280.08a32.58,32.58,0,0,0,4.84,0,32.58,32.58,0,0,0-4.84,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.56,272.93a6.67,6.67,0,0,1-12.14-4.82l2.56,1.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89,299.83h-6.54v-6.4H186.59A1.63,1.63,0,0,1,185,291.8h0a1.63,1.63,0,0,1,1.63-1.62h8V288H180.14a1.58,1.58,0,0,1-1.58-1.58h0a1.57,1.57,0,0,1,1.58-1.57h23.94v2.48h2.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.08,284.83c0,5,0,10,0,15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.09,299.83s.09-3.36.08-7.5,0-7.5-.09-7.5-.09,3.35-.08,7.5S204,299.83,204.09,299.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37,285.05c-.05,0-.09,1.89-.09,4.23s0,4.23.09,4.23.09-1.89.09-4.23S200.42,285.05,200.37,285.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.56,312.55a8.19,8.19,0,0,1,6.64-5.74H207l.48,6.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.4,298.11V273.42a1.72,1.72,0,0,0-1.33-1.68l-20.46-5.82-.2-8.1-12.23-.2-3.78-3.48-6,6.82h0l7.92,8.64,24.28,7.53.41,35.42H178.62a1.25,1.25,0,0,0-1.25,1.25v4.63h41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.04,
    y: 282.67,
    width: 13.21,
    height: 2.15,
    rx: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.08,284.83s-.11,0-.29-.06a1.05,1.05,0,0,1-.6-.52,1.08,1.08,0,0,1-.11-.58,1,1,0,0,1,1-.94H183l10.22,0a1,1,0,0,1,1,.81,1.1,1.1,0,0,1-.1.65.92.92,0,0,1-.47.44,1.53,1.53,0,0,1-.65.08h-2l-4.6,0-3.1,0-.84,0a.94.94,0,0,0-.29,0h.29l.84,0,3.1,0,4.6,0h2a1.66,1.66,0,0,0,.72-.09,1.13,1.13,0,0,0,.56-.52,1.29,1.29,0,0,0,.11-.75,1.14,1.14,0,0,0-1.12-1l-10.22,0H182a1.1,1.1,0,0,0-.77.36,1.08,1.08,0,0,0-.27.69,1.19,1.19,0,0,0,.12.61,1.08,1.08,0,0,0,.66.52A.76.76,0,0,0,182.08,284.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.37,297.91a6.34,6.34,0,1,0,6.34-6.34A6.34,6.34,0,0,0,206.37,297.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.19,298.11s0-.31.15-.85a3.49,3.49,0,0,1,2.74-2.54,3.56,3.56,0,0,1,1.81.16,3.51,3.51,0,0,1,.87.47,3.33,3.33,0,0,1,.72.73,3.41,3.41,0,0,1,0,4.06,3.12,3.12,0,0,1-.72.73,3,3,0,0,1-.87.47,3.56,3.56,0,0,1-1.81.16,3.49,3.49,0,0,1-2.74-2.54c-.14-.53-.12-.85-.15-.85a2.85,2.85,0,0,0,.08.87,3.47,3.47,0,0,0,1.28,2,3.51,3.51,0,0,0,1.5.68,3.62,3.62,0,0,0,1.89-.14,3.56,3.56,0,0,0,.92-.49,3.47,3.47,0,0,0,.76-.77,3.55,3.55,0,0,0,0-4.26,3.7,3.7,0,0,0-.76-.77,3.58,3.58,0,0,0-4.31.05,3.47,3.47,0,0,0-1.28,2A2.86,2.86,0,0,0,209.19,298.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.33 255.06 175.06 262.97 172.52 260.37 179.74 252.67 182.33 255.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.26,248l3.32,3.17a.58.58,0,0,1,0,.8l-2.83,3a.56.56,0,0,1-.81,0l-3.36-3.31a.58.58,0,0,1,0-.81l2.86-2.84A.58.58,0,0,1,171.26,248Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.31,251.88c.08.12,3.71,3.64,3.71,3.64l-2.88,3-3.66-3.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.7 320.3 217.67 320.3 219.12 318.43 173.7 318.43 173.7 320.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.2,
    y: 301.63,
    width: 11.21,
    height: 5.18,
    transform: "translate(381.61 608.45) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.2,306.81a40.84,40.84,0,0,0,0-5.11,36.31,36.31,0,0,0,0,5.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,306.81a36.31,36.31,0,0,0,0-5.11,36.31,36.31,0,0,0,0,5.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.44,306.81a36.31,36.31,0,0,0,0-5.11,40.84,40.84,0,0,0,0,5.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.57,306.81a36.31,36.31,0,0,0,0-5.11,36.31,36.31,0,0,0,0,5.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.69,306.81a36.31,36.31,0,0,0,0-5.11,36.31,36.31,0,0,0,0,5.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.82,306.81a36.31,36.31,0,0,0,0-5.11,36.31,36.31,0,0,0,0,5.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.22 320.3 168.49 320.3 168.49 329.12 222.38 329.12 222.22 320.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.91,324.7c0-.05,12-.1,26.74-.1s26.73,0,26.73.1-12,.09-26.73.09S168.91,324.75,168.91,324.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.36,286.32s1.89,33.95,5.61,37.6c2.59,2.53,7.08,2.6,13.39,4.08,6.8,1.6,21.81,1.89,21.81,1.89S104,316.41,104.11,315.56,95.36,286.32,95.36,286.32Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M119.22,273.78c-.22,1,2,33.63,2,33.63s5.81,1.44,9.86,2.27c5.32,1.09,22,3.62,22,3.62l-1.39,16.13a132.38,132.38,0,0,1-24.89-.67c-11.92-1.63-22.41-2.58-24.82-4.73-5.09-4.55-5.77-34.21-6.74-39.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.21,284.72s0,.15.09.44.12.73.18,1.3c.14,1.14.3,2.84.48,5,.39,4.35.79,10.68,1.86,18.42.28,1.93.61,4,1.05,6a27.78,27.78,0,0,0,2,6.29,6.08,6.08,0,0,0,.94,1.41,3.91,3.91,0,0,0,1.39.95,19.82,19.82,0,0,0,3.43,1.05c2.38.52,4.87.9,7.43,1.26l7.87,1c2.69.34,5.43.75,8.22,1a132.58,132.58,0,0,0,17.37.49c1.39,0,2.77-.11,4.13-.21l-.17.17,1.4-16.12.15.19c-6-.91-11.66-1.81-17-2.72l-3.95-.71c-1.3-.24-2.55-.57-3.79-.84l-7.13-1.65-.11,0v-.12c-.66-10.27-1.17-18.68-1.48-24.52-.15-2.92-.26-5.2-.31-6.75,0-.77,0-1.37,0-1.77s0-.6,0-.6,0,.05,0,.16v.44c0,.42,0,1,.09,1.77.09,1.56.22,3.83.39,6.74.38,5.85.93,14.25,1.61,24.51l-.12-.13,7.13,1.62c1.24.28,2.49.6,3.78.83l3.95.7c5.35.9,11.06,1.79,17,2.7l.17,0,0,.17c-.44,5.19-.91,10.59-1.39,16.13v.16h-.16q-2.05.15-4.14.21a131.74,131.74,0,0,1-17.43-.5c-2.81-.28-5.54-.7-8.22-1s-5.32-.68-7.88-1-5.06-.75-7.46-1.29a20.34,20.34,0,0,1-3.48-1.07,4.35,4.35,0,0,1-1.5-1,6.56,6.56,0,0,1-1-1.48,27.53,27.53,0,0,1-2-6.37c-.44-2.09-.76-4.12-1-6.06-1-7.76-1.41-14.09-1.75-18.45-.16-2.18-.29-3.88-.4-5-.06-.58-.11-1-.15-1.3S95.21,284.72,95.21,284.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,261.07l.21-.07c.13,0,.33-.1.59-.15a12.59,12.59,0,0,1,2.25-.28,13.4,13.4,0,0,1,3.34.33,12.92,12.92,0,0,1,3.8,1.55,12.69,12.69,0,0,1,3.11,2.69A12.86,12.86,0,0,1,118,268a11.86,11.86,0,0,1,.77,2.12c.08.26.11.47.14.6a1.17,1.17,0,0,1,0,.22,8.21,8.21,0,0,1-.24-.8,13.32,13.32,0,0,0-.82-2.08,13.5,13.5,0,0,0-1.82-2.77,13,13,0,0,0-3.08-2.64,13.1,13.1,0,0,0-7-1.9,12.64,12.64,0,0,0-2.23.21A7.3,7.3,0,0,1,102.86,261.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9,307.54s-.43.3-1.15.77-1.69,1.11-2.74,1.86-2,1.47-2.65,2a12.64,12.64,0,0,1-1.1.83,1.93,1.93,0,0,1,.26-.27l.75-.67c.65-.55,1.57-1.29,2.63-2s2-1.39,2.78-1.83l.88-.5A1.25,1.25,0,0,1,120.9,307.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,314.84s5.5.55,7.39-.08,2.34-1.35,4.5-1.44,11.81,0,11.81,0,8.19-.32,8.82.92a1.31,1.31,0,0,1,0,1.29c-.39.6-2.15,1-2.66,1s-11.16.45-11.16.45-.42.14,0,.32,12.69-.54,13.25.06a1.37,1.37,0,0,1-.7,2.13c-1,.28-11.3,1.72-11.71,1.62s7.45.15,8.19,0,3.85-1,4.17.05-.37,1.75-2.22,2.68a10.14,10.14,0,0,1-4.36.78,1.72,1.72,0,0,1-.88,2c-1.29.78-8.33,1.94-10.14,1.43s-15.41-1.16-15.41-1.16Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.78,325.34a34.26,34.26,0,0,1,3.76-.37c2.09-.14,3.78-.22,3.78-.17a34.26,34.26,0,0,1-3.76.37C172.47,325.31,170.78,325.39,170.78,325.34Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,212.92a6.41,6.41,0,0,0-1.42-4.92,11.93,11.93,0,0,0-4.17-3.16c-2.93-1.46-6.5-2.19-9.46-.78-3.13,1.5-4.84,5.16-4.76,8.63s2,7.08,5.35,8.05a11.06,11.06,0,0,0-3.43,2.88,1.64,1.64,0,0,0-.44,1c.07.76,1.08,1.05,1.81.86a8.78,8.78,0,0,1,2.18-.65,2.27,2.27,0,0,0-1.66,1.95,2.29,2.29,0,0,0,1.29,2.21,3,3,0,0,0,2.72-.3,8.93,8.93,0,0,0,2.06-1.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,219.13a9.63,9.63,0,0,1,2.08-2.85,16.87,16.87,0,0,1,4.91-3.54,6.33,6.33,0,0,1,5.71.57l-12.51,9.21A3.54,3.54,0,0,1,134,219.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,240.31c-3.49,8.77-10.61,16.29-18.62,18.86s-16.58-.3-20.51-7.48c-1.38-2.51-3.18-3.73-3.77-6.72-.75-3.81-1.57-7.5-1-11.58A24.12,24.12,0,0,1,135,219.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,242.48a19.18,19.18,0,0,0-2.74-21.91,26.54,26.54,0,0,0-12.18-7.1,20.69,20.69,0,0,0-9.09-1,17.93,17.93,0,0,0-8.08,3.7,45.34,45.34,0,0,0-6.3,6.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,219.19l13.59,0,.66,1.47c6.88,2.79,10.71,10.37,7.6,19.07-2.24,6.29-4.61,12.64-7.43,16.82C155.74,265,148.15,263,148.15,263s-2.06,3.13-2.06,3.13l-7.3,9.5-10.87-21.21,14.71-33.28A3.52,3.52,0,0,1,147,219.19Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.07,245.2a1.28,1.28,0,0,1-1.66.65,1.22,1.22,0,0,1-.71-1.61,1.28,1.28,0,0,1,1.66-.65A1.22,1.22,0,0,1,164.07,245.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.63,241.72c-.22.09-.79-1-2-1.56s-2.46-.38-2.52-.6.24-.3.77-.4a3.47,3.47,0,0,1,2.11.29,3.38,3.38,0,0,1,1.54,1.43C166.73,241.35,166.73,241.69,166.63,241.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.24,240.32c-.22.06-.69-1.06-1.87-1.76s-2.41-.63-2.45-.86.27-.27.81-.32a3.56,3.56,0,0,1,2.07.5,3.43,3.43,0,0,1,1.38,1.58C153.38,240,153.35,240.29,153.24,240.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.3,247.69a9.78,9.78,0,0,1,2.2.58c.33.12.67.19.82,0a1.8,1.8,0,0,0,.23-1c.06-.92.12-1.87.19-2.88.3-4.07.68-7.36.85-7.35a46.43,46.43,0,0,1-.26,7.4c-.08,1-.16,2-.23,2.87a2.08,2.08,0,0,1-.42,1.33.88.88,0,0,1-.74.23,2.86,2.86,0,0,1-.58-.18A8.86,8.86,0,0,1,154.3,247.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,263A26,26,0,0,1,137.63,254s-.07,7.9,9.39,11.28Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.36,250.46a2.46,2.46,0,0,0-1.63-1.78,2.22,2.22,0,0,0-1.77.1,1.44,1.44,0,0,0-.8,1.44,1.68,1.68,0,0,0,1.45,1.18,5.07,5.07,0,0,0,2-.21,1.36,1.36,0,0,0,.53-.2.46.46,0,0,0,.22-.47",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,246.84c.21.08-.42,1.44.3,2.95s2.22,2,2.14,2.22-.44.11-1.06-.15a3.75,3.75,0,0,1-1.83-1.78,3.28,3.28,0,0,1-.16-2.43C149.82,247.05,150.12,246.79,150.21,246.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.16,236.57c-.31.25-1.4-.61-2.89-1.27s-2.84-1-2.85-1.36c0-.19.38-.37,1-.41a5.18,5.18,0,0,1,2.41.49,5.24,5.24,0,0,1,2,1.51C156.2,236,156.31,236.44,156.16,236.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.62,236.74c-.35.18-1.07-.52-2.1-1s-2-.7-2.07-1.1c0-.18.25-.4.76-.49a3.4,3.4,0,0,1,3.36,1.69C168.8,236.3,168.78,236.65,168.62,236.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.13,216.54a7.2,7.2,0,0,1,4.22-.21,81,81,0,0,1,17.8,5c0,1.41-1.45,2.48-2.9,2.67a14.45,14.45,0,0,1-4.37-.48,5.69,5.69,0,0,0-4.25.57c-1.25.89-1.67,2.55-2.87,3.51-2.07,1.65-5.54.59-7.59,2.25-1.56,1.25-1.62,3.49-2.4,5.29a7.31,7.31,0,0,1-5.08,4.12,7.77,7.77,0,0,1-5.27-.77c3.3-6.21,5.29-13.44,8.59-19.64C142.7,217.54,144.78,217.19,146.13,216.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.64,213.8a2.81,2.81,0,0,0,.62.17c.2.05.45.1.72.19s.6.16,1,.29.72.25,1.11.42.81.37,1.25.57a19.31,19.31,0,0,1,2.66,1.67,20.14,20.14,0,0,1,2.32,2.11c.32.36.63.7.89,1s.5.66.71,1,.38.58.53.82.28.47.38.65a3.47,3.47,0,0,0,.33.55,3.76,3.76,0,0,0-.26-.59,6.07,6.07,0,0,0-.34-.67,9.82,9.82,0,0,0-.52-.85,12,12,0,0,0-.69-1c-.25-.35-.56-.69-.88-1.06a19,19,0,0,0-2.34-2.15,18.36,18.36,0,0,0-2.7-1.67c-.44-.21-.86-.41-1.27-.56a11.21,11.21,0,0,0-1.14-.4c-.35-.13-.67-.19-1-.27s-.53-.12-.73-.15A4.6,4.6,0,0,0,154.64,213.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,242.18l-.34-.28a6.16,6.16,0,0,1-1.26-7.5l1.58-3a1.7,1.7,0,0,1,2.24-.74l10.41,5L172,241.64h0a1.32,1.32,0,0,1,.64,1.71l-1.48,3.41a6.16,6.16,0,0,1-6.68,3.67l-.4-.09c-3.53-.86-5.81-3.21-5.89-4.89a30.71,30.71,0,0,1,.68-5.36.64.64,0,0,0,0-.27.61.61,0,0,0-.41-.19.58.58,0,0,0-.4.25,29.63,29.63,0,0,1-3.77,3.87c-1.06.76-3.27.74-5.56-.36A11.6,11.6,0,0,1,146.8,242.18Zm12.41-2.6,0,0,0,.06a1.21,1.21,0,0,1,0,.5,29.18,29.18,0,0,0-.68,5.25c.08,1.54,2.34,3.72,5.58,4.51l.37.08a5.74,5.74,0,0,0,6.23-3.43l1.48-3.4a.91.91,0,0,0-.43-1.18h0l-12.55-5.91-10.41-5a1.28,1.28,0,0,0-1.7.55l-1.58,3a5.76,5.76,0,0,0,1.17,7l.32.27c2.64,2,5.75,2.45,7,1.55a29.11,29.11,0,0,0,3.69-3.79.84.84,0,0,1,1.1-.32A1.34,1.34,0,0,1,159.21,239.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.77,230.84s-14.18,1.25-15.5,2.14a4.05,4.05,0,0,0-1.25,1.79,1.17,1.17,0,0,0,1.42,1.58l4.38-1.35,7.86.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,232.22a1.71,1.71,0,0,0-.35.36,5.43,5.43,0,0,0-.74,1.17,6.22,6.22,0,0,0,2.35,8.06,5.58,5.58,0,0,0,1.26.59,2.18,2.18,0,0,0,.49.11,9.2,9.2,0,0,1-1.66-.83,6.4,6.4,0,0,1-2.62-3.5,6.46,6.46,0,0,1,.32-4.36A9.51,9.51,0,0,1,147.87,232.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4,241.83a16.44,16.44,0,0,0,.88,2.54,17.35,17.35,0,0,0,1.08,2.47,16.74,16.74,0,0,0-.88-2.55A17.52,17.52,0,0,0,167.4,241.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51,240.55a7.43,7.43,0,0,0,.49,1.1c.32.67.78,1.58,1.29,2.59s1,1.91,1.36,2.56a7.2,7.2,0,0,0,.61,1,6.24,6.24,0,0,0-.48-1.1c-.32-.67-.78-1.59-1.3-2.59s-1-1.91-1.35-2.56A6.61,6.61,0,0,0,164.51,240.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,237.1c.31-.68.27-2.63-.34-3-1.65-1.1-4.93-2.46-7.07,2-2.92,6.16,3.87,7.82,4,7.65S137.22,239.43,138.3,237.1Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.08,240.52s-.14,0-.36,0a1.16,1.16,0,0,1-.81-.36,2.92,2.92,0,0,1-.1-3,3.93,3.93,0,0,1,1-1.4,1.36,1.36,0,0,1,1.19-.44.61.61,0,0,1,.5.6c0,.21-.1.31-.07.34s.18,0,.25-.32a.76.76,0,0,0-.06-.5.89.89,0,0,0-.52-.44,1.67,1.67,0,0,0-1.57.42,4,4,0,0,0-1.19,1.54,3.09,3.09,0,0,0,.31,3.41,1.27,1.27,0,0,0,1,.3C134,240.67,134.09,240.54,134.08,240.52Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.25,390H86.14a4.27,4.27,0,0,1-4.24-3.76c-.81-6.69-2.42-25.34-2.43-25.53l2.92-.25c0,.18,1.63,18.78,2.43,25.43A1.33,1.33,0,0,0,86.14,387h4.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.25,390a.93.93,0,0,0,0-.18c0-.14,0-.32,0-.55,0-.53,0-1.26,0-2.21V387h-.07l-2.29,0H86.6a3.32,3.32,0,0,1-.71,0,1.26,1.26,0,0,1-.61-.33,1.2,1.2,0,0,1-.33-.64c0-.26-.06-.55-.08-.83-.05-.56-.11-1.15-.16-1.75-.11-1.21-.23-2.5-.35-3.86-.51-5.44-1.13-12-1.79-19.08l0-.17h-.17l-2.17.19-.76.06-.18,0,0,.17c1,9.92,1.84,18.85,2.47,25.34a4.38,4.38,0,0,0,4.16,4c.56,0,1.07,0,1.53,0l2.09,0h.54c.12,0,.17,0,.17,0h-.2l-.55,0-2.08,0a6.59,6.59,0,0,1-3.17-.49A4.22,4.22,0,0,1,82,386c-.6-6.49-1.43-15.42-2.36-25.34l-.16.19.76-.06,2.17-.19-.19-.16c.69,7.1,1.32,13.64,1.85,19.09.14,1.35.26,2.64.38,3.85.06.6.12,1.19.18,1.75,0,.29.05.55.09.84a1.38,1.38,0,0,0,.4.75,1.49,1.49,0,0,0,.73.39,3.82,3.82,0,0,0,.75,0H88l2.29,0-.07-.07c0,.93,0,1.65,0,2.17,0,.23,0,.42,0,.57A.63.63,0,0,0,90.25,390Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.67,393.55H90.1a4.42,4.42,0,0,1-4.42-4.42h0a4.42,4.42,0,0,1,4.42-4.42h65.57a4.42,4.42,0,0,1,4.42,4.42h0A4.42,4.42,0,0,1,155.67,393.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.07,362.86l-8.94-70.19A4.42,4.42,0,0,1,71,287.72h0a4.43,4.43,0,0,1,5,3.83l8.95,70.19A4.43,4.43,0,0,1,81,366.69h0A4.42,4.42,0,0,1,76.07,362.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.24 390.81 167.64 474.57 163.35 474.81 146.53 393.55 155.24 390.81",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.86 390.81 79.44 474.57 83.66 474.57 99.57 393.55 90.86 390.81",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.22,393.55c0-.1-15-.17-33.52-.17s-33.52.07-33.52.17,15,.18,33.52.18S156.22,393.65,156.22,393.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.57,
    y: 328.74,
    width: 329.41,
    height: 12.61,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,307l.22,19.18a2,2,0,0,0,2,1.93h0a2,2,0,0,0,2-2.06v-19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,307H269v.05c0,2.2,0,5.13,0,8.56,0,1.72,0,3.57,0,5.5v4.51a6.89,6.89,0,0,1,0,.78,2.34,2.34,0,0,1-.26.77,2.08,2.08,0,0,1-1,.85,2.08,2.08,0,0,1-2.9-1.57,4.16,4.16,0,0,1,0-.6v-.59c0-.39,0-.78,0-1.16,0-.76,0-1.51,0-2.24,0-2.92,0-5.54-.06-7.75s0-4,0-5.21V307s0,0,0,.13v.37c0,.34,0,.82,0,1.43,0,1.24.05,3,.09,5.22s.06,4.82.11,7.72c0,.73,0,1.47,0,2.23,0,.38,0,.76,0,1.15,0,.19,0,.39,0,.59a3.58,3.58,0,0,0,0,.57A1.94,1.94,0,0,0,266.6,328a1.9,1.9,0,0,0,2-.91,1.72,1.72,0,0,0,.24-.7,6.32,6.32,0,0,0,0-.76v-4.5c0-1.94,0-3.78,0-5.5,0-3.44,0-6.37,0-8.57l.05.05L265.9,307l-.83,0h-.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.31,316.84l0,9.14a1.68,1.68,0,0,0,1.68,1.63h0a1.69,1.69,0,0,0,1.7-1.74l-.07-9Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.53,
    y: 305.64,
    width: 6.7,
    height: 4.11,
    rx: 0.44,
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,309.7a25.8,25.8,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.89,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.83,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.78,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.72,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.66,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.9,
    y: 312.31,
    width: 2.22,
    height: 9.92,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.13,322.23a.77.77,0,0,1,0-.21c0-.16,0-.34,0-.58,0-.52,0-1.22,0-2.09,0-1.78,0-4.24-.05-7l.11.1h-2.22c.21-.22.06-.06.1-.11h0v2.95c0,1,0,1.86,0,2.71,0,1.68,0,3.12,0,4.24l-.07-.07,1.63,0H268l.16,0-.57,0-1.66,0h-.06v-.06c0-1.12,0-2.56,0-4.24,0-.85,0-1.76,0-2.71v-1.46c0-.25,0-.5,0-.75v-.74h0l.12-.11h2.33v.11c0,2.84,0,5.34-.05,7.11,0,.86,0,1.56,0,2.08,0,.22,0,.4,0,.55A1.23,1.23,0,0,1,268.13,322.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.91,307l.21,19.18a2,2,0,0,0,2,1.93h0a2,2,0,0,0,2-2.06v-19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.91,307h4.26v.05c0,2.2,0,5.13,0,8.56,0,1.72,0,3.57,0,5.5v4.51a5.15,5.15,0,0,1,0,.78,2,2,0,0,1-.26.77,2,2,0,0,1-1,.85,2.08,2.08,0,0,1-2.9-1.57c0-.21,0-.41,0-.6v-.59c0-.39,0-.78,0-1.16,0-.76,0-1.51,0-2.24,0-2.92-.05-5.54-.07-7.75s0-4,0-5.21v-1.77c0-.08,0-.13,0-.12v.5c0,.34,0,.82,0,1.43,0,1.24.05,3,.09,5.22s.07,4.82.11,7.72c0,.73,0,1.47,0,2.23,0,.38,0,.76,0,1.15,0,.19,0,.39,0,.59a3.57,3.57,0,0,0,0,.57,1.92,1.92,0,0,0,1.51,1.57,1.9,1.9,0,0,0,1.15-.12,2,2,0,0,0,1.13-1.49c0-.24,0-.5,0-.76v-4.5c0-1.94,0-3.78,0-5.5,0-3.44,0-6.37,0-8.57l.05.05L257,307l-.83,0h-.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.45,316.84l0,9.14a1.69,1.69,0,0,0,1.69,1.63h0a1.69,1.69,0,0,0,1.69-1.74l-.06-9Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.66,
    y: 305.64,
    width: 6.7,
    height: 4.11,
    rx: 0.5,
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.08,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.91,309.7a25.8,25.8,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.8,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.04,
    y: 312.31,
    width: 2.22,
    height: 9.92,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.26,322.23s0-.08,0-.21,0-.34,0-.58c0-.52,0-1.22,0-2.09,0-1.78,0-4.24-.05-7l.11.1H257l.11-.11h0v2.95c0,1,0,1.86,0,2.71,0,1.68,0,3.12,0,4.24l-.06-.07,1.62,0h.44l.16,0-.56,0-1.66,0H257v-.06c0-1.12,0-2.56,0-4.24,0-.85,0-1.76,0-2.71v-2.95h0l.11-.11h2.33v.11c0,2.84,0,5.34-.05,7.11,0,.86,0,1.56,0,2.08v.55C259.27,322.17,259.27,322.23,259.26,322.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.18,307l.21,19.18a2,2,0,0,0,2,1.93h0a2,2,0,0,0,2-2.06v-19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.18,307h4.26v.05c0,2.2,0,5.13,0,8.56v5.5c0,1,0,2,0,3v1.54c0,.25,0,.51,0,.78a2.15,2.15,0,0,1-.27.77,2.06,2.06,0,0,1-.95.85,2.14,2.14,0,0,1-1.27.14,2.1,2.1,0,0,1-1.63-1.71,3.09,3.09,0,0,1,0-.6c0-.2,0-.4,0-.59,0-.39,0-.78,0-1.16,0-.76,0-1.51,0-2.24,0-2.92-.05-5.54-.06-7.75s0-4,0-5.21c0-.61,0-1.08,0-1.41,0-.15,0-.27,0-.36V307s0,0,0,.13v.37l0,1.43c0,1.24.05,3,.08,5.22s.07,4.82.11,7.72c0,.73,0,1.47,0,2.23,0,.38,0,.76,0,1.15v.59a3.57,3.57,0,0,0,0,.57A1.92,1.92,0,0,0,249,328a1.9,1.9,0,0,0,2-.91,1.88,1.88,0,0,0,.24-.7c0-.24,0-.5,0-.76v-4.5c0-1.94,0-3.78,0-5.5,0-3.44,0-6.37,0-8.57l0,.05L248.3,307l-.83,0h-.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.72,316.84l0,9.14a1.7,1.7,0,0,0,1.69,1.63h0a1.7,1.7,0,0,0,1.7-1.74l-.07-9Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.94,
    y: 305.64,
    width: 6.7,
    height: 4.11,
    rx: 0.5,
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.41,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.36,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.3,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.24,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.13,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.07,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.31,
    y: 312.31,
    width: 2.22,
    height: 9.92,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54,322.23a1.07,1.07,0,0,1,0-.21c0-.16,0-.34,0-.58,0-.52,0-1.22,0-2.09,0-1.78,0-4.24,0-7l.11.1h-2.23l.11-.11h0v2.95c0,1,0,1.86,0,2.71,0,1.68,0,3.12,0,4.24l-.07-.07,1.62,0h.44l.17,0-.57,0-1.66,0h-.06v-.06c0-1.12,0-2.56,0-4.24,0-.85,0-1.76,0-2.71v-2.95h0l.11-.11h2.33v.11c0,2.84,0,5.34,0,7.11,0,.86,0,1.56,0,2.08,0,.22,0,.4,0,.55A1.23,1.23,0,0,1,250.54,322.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.45,307l.22,19.18a2,2,0,0,0,2,1.93h0a2,2,0,0,0,2-2.06v-19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.45,307h4.26v.05c0,2.2,0,5.13,0,8.56,0,1.72,0,3.57,0,5.5v4.51a6.89,6.89,0,0,1,0,.78,2.34,2.34,0,0,1-.26.77,2.08,2.08,0,0,1-1,.85,2.08,2.08,0,0,1-2.9-1.57,4.16,4.16,0,0,1,0-.6c0-.2,0-.4,0-.59,0-.39,0-.78,0-1.16,0-.76,0-1.51,0-2.24,0-2.92,0-5.54-.06-7.75s0-4,0-5.21V307s0,0,0,.13v.37c0,.34,0,.82,0,1.43,0,1.24.05,3,.09,5.22s.06,4.82.11,7.72c0,.73,0,1.47,0,2.23,0,.38,0,.76,0,1.15,0,.19,0,.39,0,.59a3.58,3.58,0,0,0,0,.57,1.94,1.94,0,0,0,1.51,1.57,1.9,1.9,0,0,0,2-.91,1.72,1.72,0,0,0,.24-.7,6.32,6.32,0,0,0,0-.76v-4.5c0-1.94,0-3.78,0-5.5,0-3.44,0-6.37,0-8.57l0,.05-3.09-.06-.83,0h-.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,316.84l0,9.14a1.69,1.69,0,0,0,1.68,1.63h0a1.69,1.69,0,0,0,1.7-1.74l-.07-9Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.21,
    y: 305.64,
    width: 6.7,
    height: 4.11,
    rx: 0.68,
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.69,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.63,309.7a25.8,25.8,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.51,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.4,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.59,
    y: 312.31,
    width: 2.22,
    height: 9.92,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.81,322.23a.77.77,0,0,1,0-.21c0-.16,0-.34,0-.58,0-.52,0-1.22,0-2.09,0-1.78,0-4.24-.05-7l.11.1h-2.22l.11-.11h0v.74c0,.25,0,.5,0,.75v1.46c0,1,0,1.86,0,2.71,0,1.68,0,3.12,0,4.24l-.06-.07,1.62,0h.44l.16,0-.57,0-1.65,0h-.07v-.06c0-1.12,0-2.56,0-4.24,0-.85,0-1.76,0-2.71v-2.95h0l.12-.11h2.33v.11c0,2.84,0,5.34,0,7.11,0,.86,0,1.56,0,2.08,0,.22,0,.4,0,.55A1.23,1.23,0,0,1,241.81,322.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.73,307l.21,19.18a2,2,0,0,0,2,1.93h0a2,2,0,0,0,2-2.06v-19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.73,307H234v.05c0,2.2,0,5.13,0,8.56,0,1.72,0,3.57,0,5.5v4.51a5.15,5.15,0,0,1,0,.78,2,2,0,0,1-.26.77,2,2,0,0,1-1,.85,2.08,2.08,0,0,1-2.9-1.57c0-.21,0-.41,0-.6v-.59c0-.39,0-.78,0-1.16,0-.76,0-1.51,0-2.24,0-2.92,0-5.54-.07-7.75s0-4,0-5.21v-1.77c0-.08,0-.13,0-.12v.5c0,.34,0,.82,0,1.43,0,1.24,0,3,.09,5.22s.07,4.82.11,7.72c0,.73,0,1.47,0,2.23,0,.38,0,.76,0,1.15,0,.19,0,.39,0,.59a3.57,3.57,0,0,0,0,.57,1.92,1.92,0,0,0,1.51,1.57,1.9,1.9,0,0,0,1.15-.12,2,2,0,0,0,1.13-1.49c0-.24,0-.5,0-.76v-4.5c0-1.94,0-3.78,0-5.5,0-3.44,0-6.37,0-8.57l.05.05-3.09-.06-.83,0h-.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.27,316.84l0,9.14a1.69,1.69,0,0,0,1.69,1.63h0a1.69,1.69,0,0,0,1.69-1.74l-.06-9Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.48,
    y: 305.64,
    width: 6.7,
    height: 4.11,
    rx: 0.48,
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.9,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.85,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.79,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.67,309.7a25.8,25.8,0,0,1,0-4.06,22.94,22.94,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.62,309.7a22.94,22.94,0,0,1,0-4.06,25.8,25.8,0,0,1,0,4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.86,
    y: 312.31,
    width: 2.22,
    height: 9.92,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,322.23s0-.08,0-.21,0-.34,0-.58c0-.52,0-1.22,0-2.09,0-1.78,0-4.24-.05-7l.11.1h-2.22l.11-.11h0v2.95c0,1,0,1.86,0,2.71,0,1.68,0,3.12,0,4.24l-.06-.07,1.62,0h.44l.16,0-.56,0-1.66,0h-.06v-.06c0-1.12,0-2.56,0-4.24,0-.85,0-1.76,0-2.71v-2.95h0l.11-.11h2.33v.11c0,2.84,0,5.34-.05,7.11,0,.86,0,1.56,0,2.08,0,.22,0,.4,0,.55S233.09,322.23,233.08,322.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,312.31h0a.65.65,0,0,0-.66-.66H225a.65.65,0,0,0-.66.66h0a.65.65,0,0,0,.66.65h.46a.66.66,0,0,1,.66.66v13.72a.67.67,0,0,1-.66.66H225a.65.65,0,0,0-.66.65h0a.66.66,0,0,0,.66.66H273a.66.66,0,0,0,.66-.66h0A.65.65,0,0,0,273,328h-.17a.66.66,0,0,1-.65-.66V313.62a.65.65,0,0,1,.65-.66H273A.65.65,0,0,0,273.64,312.31ZM270,328H228.29a.66.66,0,0,1-.65-.66V313.62a.65.65,0,0,1,.65-.66H270a.66.66,0,0,1,.66.66v13.72A.67.67,0,0,1,270,328Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,312.31h0a.65.65,0,0,0-.66-.66H225a.65.65,0,0,0-.66.66h0a.65.65,0,0,0,.66.65h.46a.66.66,0,0,1,.66.66v13.72a.67.67,0,0,1-.66.66H225a.65.65,0,0,0-.66.65h0a.66.66,0,0,0,.66.66H273a.66.66,0,0,0,.66-.66h0A.65.65,0,0,0,273,328h-.17a.66.66,0,0,1-.65-.66V313.62a.65.65,0,0,1,.65-.66H273A.65.65,0,0,0,273.64,312.31ZM270,328H228.29a.66.66,0,0,1-.65-.66V313.62a.65.65,0,0,1,.65-.66H270a.66.66,0,0,1,.66.66v13.72A.67.67,0,0,1,270,328Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,328a1.07,1.07,0,0,0,.28-.08.67.67,0,0,0,.35-.72c0-.77,0-1.9,0-3.35s0-3.24,0-5.3c0-1,0-2.14,0-3.31,0-.3,0-.59,0-.9v-.45a1.59,1.59,0,0,0,0-.44.59.59,0,0,0-.66-.41h-1l-40.66,0a.57.57,0,0,0-.5.31.66.66,0,0,0-.05.32v10.48c0,.93,0,1.86,0,2.78v.34a.68.68,0,0,0,.06.29.57.57,0,0,0,.46.3h6.64l18.28,0,12.32,0,3.35,0h.88l.29,0h-1.17l-3.35,0-12.32,0-18.28,0h-6.65a.76.76,0,0,1-.64-.42.84.84,0,0,1-.08-.38V313.7a.85.85,0,0,1,.07-.41.78.78,0,0,1,.7-.44l40.66,0h1a.88.88,0,0,1,.5.12.78.78,0,0,1,.3.41,2,2,0,0,1,0,.48v1.35c0,1.17,0,2.27,0,3.31,0,2.06,0,3.84,0,5.3s0,2.58,0,3.35a.72.72,0,0,1-.39.74A.54.54,0,0,1,270,328Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,312.31v.09a.76.76,0,0,1-.09.25.59.59,0,0,1-.33.28c-.16.08-.38,0-.59.08a.63.63,0,0,0-.44.54c0,.27,0,.59,0,.92,0,.67,0,1.43,0,2.3,0,1.73,0,3.85,0,6.31,0,1.24,0,2.55,0,3.95a2,2,0,0,0,0,.5.58.58,0,0,0,.31.34,1.32,1.32,0,0,0,.51.06.77.77,0,0,1,.51.31.75.75,0,0,1-.28,1.07.82.82,0,0,1-.31.07h-.87l-21.76,0H225a.78.78,0,0,1-.48-.17.77.77,0,0,1-.21-.93.74.74,0,0,1,.36-.36.91.91,0,0,1,.48-.07h.42a.6.6,0,0,0,.31-.19.64.64,0,0,0,.13-.33V313.69a.54.54,0,0,0-.07-.34.55.55,0,0,0-.25-.23.81.81,0,0,0-.36-.05H225a.76.76,0,0,1,.14-1.51h7.1l21.77,0,14.67,0,4,0a1.87,1.87,0,0,1,.6.05.63.63,0,0,1,.33.28.8.8,0,0,1,.09.26v.09a.76.76,0,0,0-.11-.33.59.59,0,0,0-.32-.27,2.13,2.13,0,0,0-.59,0l-4,0-14.67,0-21.77,0h-7.1a.55.55,0,0,0-.56.33.54.54,0,0,0,.14.62.49.49,0,0,0,.3.14h.4a1.06,1.06,0,0,1,.45.07.75.75,0,0,1,.34.32.74.74,0,0,1,.1.45v13.68a.82.82,0,0,1-.19.47.73.73,0,0,1-.43.25,3.86,3.86,0,0,1-.46,0,.69.69,0,0,0-.39.05.49.49,0,0,0-.25.26.53.53,0,0,0,.15.66.61.61,0,0,0,.34.12h25.33l21.76,0h.58a1.27,1.27,0,0,0,.53-.06.58.58,0,0,0,.22-.84.56.56,0,0,0-.4-.25,1.39,1.39,0,0,1-.55-.08.75.75,0,0,1-.39-.43,2,2,0,0,1,0-.54c0-1.4,0-2.71,0-3.95,0-2.46,0-4.58,0-6.31,0-.87,0-1.63,0-2.3,0-.34,0-.64,0-.93a.68.68,0,0,1,.49-.57c.23-.06.43,0,.59-.07a.62.62,0,0,0,.32-.26A.8.8,0,0,0,273.64,312.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.69,
    y: 332.21,
    width: 9.29,
    height: 142.37,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.21,
    y: 328.74,
    width: 9.29,
    height: 146.03,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,293.28h0a.72.72,0,0,0,.72.72H286v13.08l-7.89,17.53a3,3,0,0,0,2.73,4.23h15.68a3,3,0,0,0,2.73-4.24l-8.2-18.08V294.08h1.17a.76.76,0,0,0,.76-.76h0a.76.76,0,0,0-.76-.76h-7.51A.72.72,0,0,0,284,293.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,293.28a.48.48,0,0,1,0-.21.74.74,0,0,1,.4-.48,3.17,3.17,0,0,1,1-.09h1.39l3.83,0h1.17a2.82,2.82,0,0,1,.64,0,.88.88,0,0,1,.55.45.9.9,0,0,1-.51,1.25,3.09,3.09,0,0,1-.73,0h-.71l.14-.14c0,3.49,0,7.71,0,12.44v-.07l5.59,12.29,1.53,3.35c.25.57.51,1.14.77,1.71a5.15,5.15,0,0,1,.61,1.87,3.22,3.22,0,0,1-2.15,3.2,3.27,3.27,0,0,1-1,.17H281.44a5.63,5.63,0,0,1-1.34-.09,3.24,3.24,0,0,1-2.07-1.64,3.15,3.15,0,0,1-.15-2.58c.33-.79.67-1.5,1-2.24,2.65-5.84,5-11.09,7-15.47v.06c0-6.05.07-10.58.09-13.08l.06.06H285a.88.88,0,0,1-.72-.22.63.63,0,0,1-.21-.55.84.84,0,0,0,.25.5.82.82,0,0,0,.68.18l1.08,0h.06V294c0,2.5,0,7,.09,13.08v0l0,0-6.93,15.5c-.32.73-.67,1.48-1,2.22a2.8,2.8,0,0,0,1.95,3.68,5,5,0,0,0,1.24.08h15.13a2.68,2.68,0,0,0,.89-.15,2.79,2.79,0,0,0,1.87-2.78,4.82,4.82,0,0,0-.56-1.72l-.78-1.71c-.51-1.13-1-2.25-1.51-3.35l-5.56-12.31v-.08c0-4.73,0-8.95,0-12.44V294h.84a3.36,3.36,0,0,0,.65,0,.64.64,0,0,0,.38-.9.6.6,0,0,0-.4-.33,2.71,2.71,0,0,0-.58,0h-1.17l-3.83,0-1.39,0a3.32,3.32,0,0,0-1,.05.67.67,0,0,0-.39.42C284,293.21,284,293.28,284,293.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.94,294a27.07,27.07,0,0,1-6.73,0,27.07,27.07,0,0,1,6.73,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.62,269.86h0a.72.72,0,0,0,.72.72h1.29v13.08l-7.89,17.53a3,3,0,0,0,2.73,4.22h15.68a3,3,0,0,0,2.73-4.23l-8.2-18.08V270.66h1.17a.76.76,0,0,0,.76-.76h0a.76.76,0,0,0-.76-.76h-7.51A.72.72,0,0,0,384.62,269.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.62,269.86a.48.48,0,0,1,0-.21.74.74,0,0,1,.4-.48,3.14,3.14,0,0,1,1-.09l1.38,0,3.84,0h1.17a3.63,3.63,0,0,1,.64,0,.85.85,0,0,1,.55.45.9.9,0,0,1-.51,1.25,3.09,3.09,0,0,1-.73,0h-.71l.14-.13c0,3.49,0,7.71,0,12.44l0-.07c1.72,3.76,3.6,7.89,5.6,12.29l1.52,3.35.78,1.71a5.09,5.09,0,0,1,.61,1.87,3.22,3.22,0,0,1-2.15,3.2,3.27,3.27,0,0,1-1,.17H382a5.14,5.14,0,0,1-1.34-.1,3.19,3.19,0,0,1-2.07-1.63,3.15,3.15,0,0,1-.15-2.58c.33-.79.67-1.5,1-2.24,2.65-5.85,5-11.09,7-15.47v.06c0-6.06.07-10.58.09-13.08l.06.06h-1.08a.92.92,0,0,1-.72-.22.64.64,0,0,1-.21-.55.75.75,0,0,0,.93.67h1.14v.06c0,2.5,0,7,.08,13.08v.06l-6.93,15.51c-.32.73-.68,1.48-1,2.22a2.8,2.8,0,0,0,1.95,3.68,5,5,0,0,0,1.24.08h15.13a2.68,2.68,0,0,0,.89-.15,2.8,2.8,0,0,0,1.87-2.78,4.59,4.59,0,0,0-.57-1.72l-.77-1.71-1.52-3.35c-2-4.41-3.85-8.55-5.55-12.32v-.07c0-4.73,0-9,0-12.44v-.13h.84a2.68,2.68,0,0,0,.65,0,.64.64,0,0,0,.38-.9.66.66,0,0,0-.4-.33,3.62,3.62,0,0,0-.58,0h-1.17l-3.84,0-1.38,0a3.37,3.37,0,0,0-1,0,.71.71,0,0,0-.39.43C384.63,269.79,384.63,269.86,384.62,269.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.54,270.6a27.07,27.07,0,0,1-6.73,0,27.07,27.07,0,0,1,6.73,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,328.57H304.83a2.68,2.68,0,0,1-2.69-2.69V303.74h20.32l-2.06,2v20.1A2.68,2.68,0,0,1,317.72,328.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,328.57s.16,0,.45-.07a2.64,2.64,0,0,0,1.16-.54,2.59,2.59,0,0,0,1-1.76c0-.81,0-1.78,0-2.84,0-4.3,0-10.38-.07-17.58v-.07l.05,0,2-2.05.12.28-16.18,0h-4.14l.18-.18c0,5.51,0,10.72,0,15.44,0,2.36,0,4.59,0,6.67a2.57,2.57,0,0,0,1.42,2.32,2.69,2.69,0,0,0,1.31.27h1.36l8.32.05,2.25,0h.58l.2,0-.2,0h-.58l-2.25,0-8.32.05H305a3,3,0,0,1-1.43-.29,2.83,2.83,0,0,1-1.58-2.56c0-2.08,0-4.31,0-6.67,0-4.72,0-9.93,0-15.44v-.18h20.9l-.28.29-2.06,2,.05-.11c0,7.2-.05,13.28-.07,17.58,0,1.07,0,2,0,2.86a2.71,2.71,0,0,1-1.07,1.82,2.53,2.53,0,0,1-1.21.51A1.46,1.46,0,0,1,317.72,328.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.36,315.35h15.89a0,0,0,0,1,0,0v6.74a5.32,5.32,0,0,1-5.32,5.32h-5.26a5.32,5.32,0,0,1-5.32-5.32v-6.74A0,0,0,0,1,303.36,315.35Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.05,310a23.46,23.46,0,0,1-4.74,0,25.59,25.59,0,0,1,4.74,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.42,307.37a2.69,2.69,0,0,1-1.06.11,2.62,2.62,0,0,1-1.05-.11,2.34,2.34,0,0,1,1.05-.12A2.4,2.4,0,0,1,304.42,307.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.05,315.23a23.46,23.46,0,0,1-4.74,0,25.59,25.59,0,0,1,4.74,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.42,312.6a2.69,2.69,0,0,1-1.06.11,2.62,2.62,0,0,1-1.05-.11,2.62,2.62,0,0,1,1.05-.11A2.69,2.69,0,0,1,304.42,312.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.05,320.47a25.59,25.59,0,0,1-4.74,0,23.46,23.46,0,0,1,4.74,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.42,317.83a2.4,2.4,0,0,1-1.06.12,2.34,2.34,0,0,1-1.05-.12,2.62,2.62,0,0,1,1.05-.11A2.69,2.69,0,0,1,304.42,317.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.05,325.7a23.46,23.46,0,0,1-4.74,0,25.59,25.59,0,0,1,4.74,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.42,323.07a2.69,2.69,0,0,1-1.06.11,2.62,2.62,0,0,1-1.05-.11,2.34,2.34,0,0,1,1.05-.12A2.4,2.4,0,0,1,304.42,323.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.44,329h29a2.43,2.43,0,0,0,2.43-2.43h0a2.43,2.43,0,0,0-2.43-2.43h-29a2.43,2.43,0,0,0-2.43,2.43h0A2.43,2.43,0,0,0,379.44,329Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.13,328.92h0a.89.89,0,0,1-.9-.89V268.62a.89.89,0,0,1,.9-.89h0a.89.89,0,0,1,.89.89V328A.89.89,0,0,1,405.13,328.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.74,280.28h-24a.89.89,0,0,1-.89-.89h0a.89.89,0,0,1,.89-.89h24a.89.89,0,0,1,.89.89h0A.89.89,0,0,1,408.74,280.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.12,279.39a3,3,0,1,1-3-3A3,3,0,0,1,408.12,279.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.72,268.05a15.18,15.18,0,0,0-11,4.68l-6-3.46L322,274l5.69,3.28a15.24,15.24,0,1,0,14-9.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.72,268.05a.9.9,0,0,1,.28,0l.83,0a9.22,9.22,0,0,1,1.34.13,12.54,12.54,0,0,1,1.81.38,15.37,15.37,0,0,1,11.19,14.86,17,17,0,0,1-.69,4.5,16.3,16.3,0,0,1-2.15,4.32,15.47,15.47,0,0,1-27.25-3.93,16.22,16.22,0,0,1-.83-5.73,15.56,15.56,0,0,1,1.23-5.36l.1.3-5.68-3.3-.19-.11.11-.19,2.76-4.75.1-.17.17.1,6,3.49-.2,0a15.22,15.22,0,0,1,7.87-4.32,11.2,11.2,0,0,1,3.22-.25l-.21,0-.61,0a19.49,19.49,0,0,0-2.37.36,15.38,15.38,0,0,0-7.67,4.37l-.08.09-.12-.06-6-3.43.27-.07c-.85,1.5-1.76,3.08-2.73,4.77l-.08-.3,5.71,3.27.18.1-.08.2a14.68,14.68,0,0,0-1.17,5.19,15.59,15.59,0,0,0,.81,5.54A15,15,0,0,0,353.94,292a14.79,14.79,0,0,0,2.79-8.54,15.12,15.12,0,0,0-2-7.63,15.29,15.29,0,0,0-8.85-7A20.72,20.72,0,0,0,341.72,268.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.75,284.35s2.51,13.63,14.17,12.15,12.3-13.22,12.3-13.22-7.68,2.72-14.4-1C331.19,277,328.75,284.35,328.75,284.35Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.87,293s-2.2,4.71-3.92,8.12c-.67,1.33-.29,3.24,1.95,3.2h14.84c1.75,0,2.7-1.88,1.76-3.6l-3.91-7.84Z",
    style: {
      fill: "#5EFF64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.76,291.57l-8,36.58a1,1,0,0,1-1.12.72h0a1,1,0,0,1-.71-1.12l8-36.58a.94.94,0,0,1,1.12-.71h0A.93.93,0,0,1,334.76,291.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.25,291.07l8.67,36.42a.94.94,0,0,1-.69,1.13h0a.93.93,0,0,1-1.13-.7l-8.67-36.41a.94.94,0,0,1,.69-1.13h0A.94.94,0,0,1,351.25,291.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,291.31l1.86,37.39a.94.94,0,0,1-.89,1h0a.94.94,0,0,1-1-.89l-1.86-37.39a.94.94,0,0,1,.89-1h0A.94.94,0,0,1,343.6,291.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.59,291.16H326.74a.94.94,0,0,1-.94-.94h0a.94.94,0,0,1,.94-.94h30.85a.94.94,0,0,1,.94.94h0A.94.94,0,0,1,357.59,291.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.59,291.16a1.34,1.34,0,0,0,.59-.28.92.92,0,0,0,.27-.7.88.88,0,0,0-.61-.76c-1.64,0-4.17,0-7.21.05l-23.89.07a.68.68,0,0,0-.65.87.65.65,0,0,0,.4.44,2.47,2.47,0,0,0,.76,0h3.35l6.35,0,10.74.05,7.24.09,2,0a3.15,3.15,0,0,1,.69.06,3.75,3.75,0,0,1-.69,0l-2,.05-7.24.08L337,291.4H326.82a1.63,1.63,0,0,1-.51-.08,1.2,1.2,0,0,1,.43-2.32l23.89.08c3.07,0,5.51,0,7.27.13a1,1,0,0,1,.7.94,1,1,0,0,1-.35.78A.77.77,0,0,1,357.59,291.16Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ1);
export default __webpack_public_path__ + "static/media/j1.3846e734033b2f69a339af8bc80d10df.svg";
export { ForwardRef as ReactComponent };